// Translations for Roady Oliveira de Azeméis Website
// English and Portuguese text mappings

const translations = {
    NAVIGATION: {
        start: {
            pt: 'Início',
            en: 'Start'
        },
        store: {
            pt: 'Loja',
            en: 'Store'
        },
        tires: {
            pt: 'Pneus',
            en: 'Tires'
        },
        workshop: {
            pt: 'Oficina',
            en: 'Workshop'
        },
        mobility: {
            pt: 'Mobilidade',
            en: 'Mobility'
        },
        budget: {
            pt: 'Orçamento',
            en: 'Budget'
        },
        weCall: {
            pt: 'Nós ligamos',
            en: "We'll call"
        },
        weCallClick: {
            pt: 'Clique aqui',
            en: 'Click here'
        },
        recruitment: {
            pt: 'Recrutamento',
            en: 'Recruitment'
        },
        contact: {
            pt: 'Contacte-nos',
            en: 'Contact Us'
        }
    },

    HEADER: {
        welcome: {
            pt: 'Bem-vindo ao Roady Centro-Auto Oliveira de Azeméis',
            en: 'Welcome to Roady Centro-Auto Oliveira de Azeméis'
        },
        schedule: {
            pt: 'Seg-Sáb 8h30-20h | Domingo 9h-12 / 14h-19h',
            en: 'Mon-Sat 8:30AM-8:00PM | Sun 9:00AM-12:00PM / 2:00PM-7:00PM'
        }
    },

    HERO: {
        slider1: {
            subtitle: {
                pt: 'Conduza Suave, Conduza Seguro',
                en: 'Drive Smooth, Drive Safe'
            },
            title: {
                pt: 'Serviços de Reparação e <br> Manutenção Automóvel <br> <span>em que Pode Confiar</span>',
                en: 'Expert Car Repair & <br> Maintenance Services <br> <span>You Can Trust</span>'
            },
            text: {
                pt: 'Oferta de serviços desde diagnósticos de motor até <br> manutenção de rotina com substituição de oleo e filtros . <br> Serviço de qualidade executado por mecânicos certificados.',
                en: 'We offer services from engine diagnostics to <br> routine oil and filters changes. <br> Quality service delivered by certified mechanics.'
            }
        },
        slider2: {
            subtitle: {
                pt: 'O Seu Carro, O Nosso Cuidado',
                en: 'Your Car, Our Care'
            },
            title: {
                pt: 'Soluções Completas de <br> Reparação Automóvel por <br><span>Técnicos</span> <span>Certificados</span>',
                en: 'Complete Auto Repair <br> Solutions by <span>Certified</span> <br> <span>Technicians</span>'
            },
            text: {
                pt: 'Oferta de serviços desde diagnósticos de motor até <br> manutenção de rotina com substituição de oleo e filtros . <br> Serviço de qualidade executado por mecânicos certificados.',
                en: 'We offer services from engine diagnostics to <br> routine oil and filters changes. <br> Quality service delivered by certified mechanics.'
            }
        },
        slider3: {
            subtitle: {
                pt: 'Desempenho em que Pode Confiar',
                en: 'Performance You Can Rely On'
            },
            title: {
                pt: 'Rápidos, Confiáveis e  Acessíveis <br><span>Serviços Automóveis</span> <br> para Cada Modelo',
                en: 'Fast, Reliable, and <br> Affordable <span>Car Services</span> <br> for Every Model'
            },
            text: {
                pt: 'Oferta de serviços desde diagnósticos de motor até <br> manutenção de rotina com substituição de oleo e filtros . <br> Serviço de qualidade executado por mecânicos certificados.',
                en: 'We offer services from engine diagnostics to <br> routine oil and filters changes. <br> Quality service delivered by certified mechanics.'
            }
        }
    },

    CATALOG: {
        slidingText: {
            pt: 'SERVIÇOS AUTOMÓVEL ',
            en: 'CAR SERVICES '
        },
        tagline: {
            pt: 'Os Nossos Serviços',
            en: 'Our Services'
        },
        title: {
            pt: 'Serviços Automóvel, <span style="color: #ea2127;">Manutenção e Equipamentos</span> para o seu Carro',
            en: 'Car Services, <span style="color: #ea2127;">Maintenance and Equipment</span> for Your Vehicle'
        },
        text: {
            pt: 'Encontre serviços automóvel completos, desde mudança de óleo, revisão, travões e alinhamento, até diagnóstico e manutenção especializada.<br>Soluções pensadas para garantir segurança, desempenho e confiança em cada quilómetro.',
            en: 'Find complete car services, from oil changes, inspections, brakes and alignment, to diagnostics and specialized maintenance.<br>Solutions designed to ensure safety, performance and confidence on every kilometer.'
        },
        previewTitle: {
            pt: 'Catálogo Roady Oliveira de Azeméis',
            en: 'Roady Oliveira de Azeméis Catalog'
        },
        previewEdition: {
            pt: 'Página 1 - Capa',
            en: 'Page 1 - Cover'
        },
        clickToViewFull: {
            pt: 'Clique para Ver Catálogo Completo',
            en: 'Click to View Full Catalog'
        },
        downloadFullPDF: {
            pt: 'Descarregar PDF Completo',
            en: 'Download Full PDF'
        },
        october2025Edition: {
            pt: 'Edição de Outubro 2025',
            en: 'October 2025 Edition'
        },
        pageCover: {
            pt: 'Página 1 - Capa',
            en: 'Page 1 - Cover'
        }
    },

    ABOUT: {
        tagline: {
            pt: 'Sobre Nós',
            en: 'About Us'
        },
        title: {
            pt: 'A Nossa Especialização<br>está na Reparação e<br>Manutenção Automóvel.',
            en: 'Our Expertise<br>Lies in Vehicle Repair<br>and Maintenance.'
        },
        text: {
            pt: 'Com mais de 24 anos de experiência, o Roady Oliveira de Azeméis garante um serviço técnico de excelência em todas as áreas da manutenção automóvel.<br>Apostamos em diagnóstico preciso, intervenção rigorosa e acompanhamento profissional — tudo para assegurar o melhor desempenho e segurança do seu veículo.',
            en: 'With over 24 years of experience, Roady Oliveira de Azeméis guarantees excellent technical service in all areas of vehicle maintenance.<br>We invest in precise diagnosis, rigorous intervention and professional follow-up — all to ensure the best performance and safety of your vehicle.'
        },
        fastService: {
            pt: 'Serviço técnico especializado',
            en: 'Specialized technical service'
        },
        fastServiceText: {
            pt: 'Intervenções realizadas por técnicos certificados e equipamentos de diagnóstico avançado.',
            en: 'Interventions performed by certified technicians and advanced diagnostic equipment.'
        },
        onlineSupport: {
            pt: 'Suporte completo e proximidade',
            en: 'Complete support and proximity'
        },
        onlineSupportText: {
            pt: 'Aconselhamento personalizado e acompanhamento contínuo dos nossos clientes.',
            en: 'Personalized advice and continuous follow-up of our customers.'
        },
        qualityControlSystem: {
            pt: 'Sistema interno de controlo de qualidade',
            en: 'Internal quality control system'
        },
        affordableCost: {
            pt: 'Equipa técnica certificada',
            en: 'Certified technical team'
        },
        bestTireBrands: {
            pt: 'As melhores marcas internacionais de pneus',
            en: 'The best international tire brands'
        },
        expressOilChange: {
            pt: 'Mudança de óleo express',
            en: 'Express oil change'
        },
        yearsExperience: {
            pt: 'Anos De Experiência',
            en: 'Years Of Experience'
        },
        experienceText: {
            pt: 'Anos De Experiência',
            en: 'Years Of Experience'
        },
        reviewText: {
            pt: 'Clientes 4.8 (3,567 Avaliações)',
            en: 'Clients 4.8 (3,567 Reviews)'
        },
        certifiedTeam: {
            pt: 'Equipa técnica certificada',
            en: 'Certified technical team'
        },
        clientsReviews: {
            pt: 'Clientes 4.8 (3,567 Avaliações)',
            en: 'Clients 4.8 (3,567 Reviews)'
        },
        authorName: {
            pt: 'Dainel Brain',
            en: 'Dainel Brain'
        },
        authorTitle: {
            pt: 'Co-Fundador',
            en: 'Co-Founder'
        },
        danielBrain: {
            pt: 'Dainel Brain',
            en: 'Dainel Brain'
        }
    },

    SERVICES: {
        tagline: {
            pt: 'Os Nossos Serviços',
            en: 'Our Services'
        },
        servicesTagline: {
            pt: 'Os Nossos Serviços',
            en: 'Our Services'
        },
        title: {
            pt: 'O que <span style="color: #ea2127;">fazemos</span>',
            en: 'What <span style="color: #ea2127;">we do</span>'
        },
        alignment: {
            pt: 'Alinhamento',
            en: 'Alignment'
        },
        alignmentDesc: {
            pt: 'Essencial para a estabilidade e segurança do veículo, o alinhamento garante conforto na condução e reduz o desgaste irregular dos pneus.',
            en: 'Essential for vehicle stability and safety, alignment ensures comfortable driving and reduces irregular tire wear.'
        },
        diagnosticTest: {
            pt: 'Teste Diagnóstico',
            en: 'Diagnostic Test'
        },
        diagnosticTestDesc: {
            pt: 'Utilizamos tecnologia avançada para identificar falhas no sistema eletrónico e mecânico, assegurando o desempenho ideal do automóvel.',
            en: 'We use advanced technology to identify failures in the electronic and mechanical systems, ensuring optimal vehicle performance.'
        },
        roadyReview: {
            pt: 'Revisão Roady',
            en: 'Roady Review'
        },
        roadyReviewDesc: {
            pt: 'Executamos revisões completas de acordo com as normas do fabricante, mantendo a garantia, o desempenho e a fiabilidade do veículo.',
            en: 'We perform complete maintenance according to manufacturer standards, maintaining warranty, performance and vehicle reliability.'
        },
        shockAbsorbers: {
            pt: 'Amortecedores',
            en: 'Shock Absorbers'
        },
        shockAbsorbersDesc: {
            pt: 'Substituímos amortecedores, melhorando a estabilidade e a travagem do veículo, para maior segurança em cada viagem.',
            en: 'We replace shock absorbers in poor condition, improving vehicle stability and braking, for greater safety on every trip.'
        },
        inspection: {
            pt: 'Inspeção',
            en: 'Inspection'
        },
        inspectionDesc: {
            pt: 'Realizamos inspeções preventivas para garantir o bom funcionamento de todos os sistemas, reduzindo riscos e custos futuros.',
            en: 'We perform preventive inspections to ensure the proper functioning of all systems, reducing risks and future costs.'
        },
        generalMechanics: {
            pt: 'Mecânica Geral',
            en: 'General Mechanics'
        },
        generalMechanicsDesc: {
            pt: 'A nossa equipa assegura reparações mecânicas de precisão, prolongando a durabilidade e bom desempenho do automóvel.',
            en: 'Our team ensures precision mechanical repairs, extending the vehicle\'s durability and good performance.'
        },
        workshopServices: {
            pt: 'Pacote de Serviços de Oficina',
            en: 'Workshop Services Pack'
        },
        workshopServicesDesc: {
            pt: 'Programas de manutenção completos e personalizados para cada veículo, assegurando eficiência e tranquilidade durante todo o ano.',
            en: 'Complete and personalized maintenance programs for each vehicle, ensuring efficiency and peace of mind throughout the year.'
        },
        airConditioning: {
            pt: 'Ar Condicionado',
            en: 'Air Conditioning'
        },
        airConditioningDesc: {
            pt: 'Verificamos e recarregamos o sistema de ar condicionado, garantindo conforto térmico e um funcionamento eficiente do equipamento.',
            en: 'We check and recharge the air conditioning system, ensuring thermal comfort and efficient equipment operation.'
        },
        washing: {
            pt: 'Lavagem',
            en: 'Washing'
        },
        washingDesc: {
            pt: 'Centro de lavagem self-service no exterior, prático e acessível, onde pode cuidar do seu veículo com produtos de qualidade e espaço preparado para cada necessidade.',
            en: 'Outdoor self-service car wash center, practical and accessible, where you can care for your vehicle with quality products and space prepared for every need.'
        },
        headlightRestoration: {
            pt: 'Restauro de Faróis',
            en: 'Headlight Restoration'
        },
        headlightRestorationDesc: {
            pt: 'Eliminamos o desgaste e a opacidade dos faróis, recuperando a luminosidade original e melhorando a visibilidade e segurança na estrada.',
            en: 'We eliminate wear and opacity from headlights, restoring original brightness and improving visibility and road safety.'
        },
        batteries: {
            pt: 'Baterias',
            en: 'Batteries'
        },
        batteriesDesc: {
            pt: 'Verificamos e substituímos baterias automóvel, assegurando um arranque fiável e o correto funcionamento dos sistemas elétricos.',
            en: 'We check and replace automotive batteries, ensuring reliable start and proper functioning of electrical systems.'
        },
        brakes: {
            pt: 'Travões',
            en: 'Brakes'
        },
        brakesDesc: {
            pt: 'Fazemos a substituição e manutenção completa dos travões, garantindo resposta imediata e máxima segurança em todas as condições.',
            en: 'We perform complete brake replacement and maintenance, ensuring immediate response and maximum safety in all conditions.'
        },
        autoRepair: {
            pt: 'Reparação Automóvel',
            en: 'Auto Car Repair'
        },
        brakeInspection: {
            pt: 'Inspeção Segura de Travões',
            en: 'Brake Safe Inspection'
        },
        engineDiagnostics: {
            pt: 'Diagnósticos de Motor',
            en: 'Engine Diagnostics'
        },
        tireReplacement: {
            pt: 'Substituição de Pneus',
            en: 'Tire Replacement'
        },
        oilChange: {
            pt: 'Mudança de Óleo',
            en: 'Oil Change'
        },
        batteryService: {
            pt: 'Serviço de Bateria',
            en: 'Battery Service'
        },
        premiumQualityProducts: {
            pt: 'Campanhas e<br>preços atualizados',
            en: 'Updated Campaigns<br>and Prices'
        },
        expertRecommendations: {
            pt: 'Diagnóstico e<br>aconselhamento técnico',
            en: 'Diagnostics and<br>Technical Advice'
        },
        bestPricesGuaranteed: {
            pt: 'Soluções completas<br>para o seu carro',
            en: 'Complete Solutions<br>for Your Car'
        },
        specialPromotions: {
            pt: 'Atendimento personalizado<br>e de confiança',
            en: 'Personalized and<br>Trusted Service'
        },
        needHelpChoosing: {
            pt: 'Precisa de ajuda a escolher o serviço certo?',
            en: 'Need help choosing the right service?'
        }
    },

    BEFORE_AFTER: {
        before: {
            pt: 'Antes',
            en: 'Before'
        },
        after: {
            pt: 'Depois',
            en: 'After'
        },
        fromWornToWow: {
            pt: 'Rigor Técnico, Resultados Visíveis',
            en: 'Technical Rigor, Visible Results'
        },
        watchHowWeBringLife: {
            pt: '<span style="color: #ea2127;">Polimento e Restauro</span><br>de Faróis em Oliveira de Azeméis' ,
            en: 'Headlight <span style="color: #ea2127;">Polishing and Restoration</span><br>in Oliveira de Azeméis'
        },
        realResultsSpeak: {
            pt: 'No Roady Oliveira de Azeméis realizamos polimento e restauro de faróis, recuperando a transparência e melhorando a iluminação e o aspeto do seu veículo. Utilizamos equipamentos adequados e técnicas profissionais para remover o desgaste e devolver aos faróis uma aparência renovada, com rigor e atenção ao detalhe.',
            en: 'At Roady Oliveira de Azeméis we perform headlight polishing and restoration, recovering transparency and improving your vehicle\'s lighting and appearance. We use proper equipment and professional techniques to remove wear and give your headlights a renewed look, with rigor and attention to detail.'
        },
        fullBodyRepair: {
            pt: 'Polimento de faróis',
            en: 'Headlight polishing'
        },
        dentRepaired: {
            pt: 'Recuperação de faróis baços e amarelados',
            en: 'Restoration of dull and yellowed headlights'
        },
        engineRepair: {
            pt: 'Melhoria da transparência e visibilidade',
            en: 'Improved transparency and visibility'
        }
    },

    WHY_CHOOSE_US: {
        slidingText: {
            pt: 'PNEUS PARA TODAS AS ESTAÇÕES',
            en: 'TYRES FOR ALL SEASONS'
        },
        tagline: {
            pt: 'Pneus para Todas as Estações',
            en: 'Tyres for All Seasons'
        },
        title: {
            pt: 'Marcas de confiança, preços competitivos e segurança em cada quilómetro.',
            en: 'Trusted brands, competitive prices and safety in every kilometer.'
        },
        text: {
            pt: 'No Roady Oliveira de Azeméis encontra uma ampla seleção de pneus<br>das principais marcas, desde opções acessíveis a gamas premium.<br>Com aconselhamento técnico, montagem profissional<br>e equilibragem precisa, garantimos desempenho,<br>segurança e confiança em todas as estações do ano.',
            en: 'At Roady Oliveira de Azeméis you will find a wide selection of tyres<br>from leading brands, from affordable options to premium ranges.<br>With technical advice, professional fitting<br>and precise balancing, we guarantee performance,<br>safety and confidence in all seasons of the year.'
        },
        awardWinning: {
            pt: 'Prémios Ganhos',
            en: 'award Winning'
        },
        vehiclesRepaired: {
            pt: 'Veículos Reparados',
            en: 'Vehicles Repaired'
        },
        happyCustomers: {
            pt: 'Clientes Satisfeitos',
            en: 'Happy Customers'
        },
        certifiedExperts: {
            pt: 'Especialistas Certificados',
            en: 'Certified Experts'
        },
        ecoFriendlyCleaning: {
            pt: 'Produtos de Limpeza<br>Ecológicos',
            en: 'Eco-Friendly Cleaning<br>Products'
        },
        trainedProfessionalTeam: {
            pt: 'Equipa Treinada e<br>Profissional',
            en: 'Trained & Professional<br>Team'
        },
        satisfactionGuarantee: {
            pt: 'As melhores marcas internacionais de pneus',
            en: 'The best international tire brands'
        },
        flexibleScheduling: {
            pt: 'Peça orçamento<br>sem compromisso',
            en: 'No-obligation<br>Quotes'
        },
        affordableTransparentPricing: {
            pt: 'Preços Acessíveis e<br>Transparentes',
            en: 'Affordable & Transparent<br>Pricing'
        },
        affordableCost: {
            pt: 'Equipa técnica certificada',
            en: 'Certified technical team'
        },
        certifiedTeam: {
            pt: 'Equipa técnica certificada',
            en: 'Certified technical team'
        },
        needAssistance: {
            pt: 'Precisa de assistência? Entre em contacto com o Sr. Robertson G.',
            en: 'Need assistance? Reach out to Mr. Robertson G.'
        }
    },

    TEAM: {
        tagline: {
            pt: 'Técnico Especialista',
            en: 'Expert Technician'
        },
        title: {
            pt: 'Conheça os Especialistas que Mantêm o Seu Carro a Funcionar Suavemente',
            en: 'Meet the Experts Who Keep Your Car Running Smoothly'
        },
        tireTechnician: {
            pt: 'Técnico de Pneus',
            en: 'Tire Technician'
        },
        transmissionSpecialist: {
            pt: 'Especialista em Transmissão',
            en: 'Transmission Specialist'
        },
        brakeSpecialist: {
            pt: 'Especialista em Travões',
            en: 'Brake Specialist'
        },
        engineExpert: {
            pt: 'Especialista em Motores',
            en: 'Engine Expert'
        }
    },

    TESTIMONIALS: {
        founder: {
            pt: 'Fundador',
            en: 'Founder'
        }
    },

    PRICING: {
        basicPlan: {
            pt: 'Plano Básico',
            en: 'Basic Plan'
        },
        standardPlan: {
            pt: 'Plano Standard',
            en: 'Standard Plan'
        },
        premiumPlan: {
            pt: 'Plano Premium',
            en: 'Premium Plan'
        },
        perDay: {
            pt: '/Por Dia',
            en: '/Per Day'
        },
        transparentPricing: {
            pt: 'Preços Transparentes',
            en: 'Transparent Pricing'
        },
        howWeWork: {
            pt: 'Como trabalhamos',
            en: 'How we work'
        },
        oilReviewIncluded: {
            pt: 'Revisões Roady',
            en: 'Roady Reviews'
        },
        pricingIntroText: {
            pt: 'Revisões adaptadas a cada veículo, realizadas por técnicos certificados com controlo total de qualidade.',
            en: 'Reviews adapted to each vehicle, performed by certified technicians with total quality control.'
        },
        oilReview: {
            pt: 'Revisão com Óleo',
            en: 'Oil Review'
        },
        oil10W40Filter: {
            pt: 'Óleo 10W40 + Filtro',
            en: '10W40 Oil + Filter'
        },
        oilReviewFilter: {
            pt: 'Revisão com Óleo + Filtro',
            en: 'Oil Review + Filter'
        },
        cepsa5W40Filter: {
            pt: 'CEPSA 5W40 + Filtro',
            en: 'CEPSA 5W40 + Filter'
        },
        customReview: {
            pt: 'Revisão Personalizada',
            en: 'Custom Review'
        },
        withFilterOilSeparate: {
            pt: 'Com Filtro - Óleo separado',
            en: 'With Filter - Oil separate'
        },
        laborVerification: {
            pt: 'Mão de obra + Verificação',
            en: 'Labor + Verification'
        },
        controlPointsReposition: {
            pt: 'Pontos de Controlo (1) + Reposição',
            en: 'Control Points (1) + Reposition'
        },
        windowCleaner: {
            pt: 'Limpa Vidros',
            en: 'Window Cleaner'
        },
        oilFilterIncluded: {
            pt: 'Filtro de Óleo Incluído',
            en: 'Oil Filter Included'
        },
        oilPurchasedSeparately: {
            pt: 'Óleo adquirido separadamente',
            en: 'Oil purchased separately'
        },
        bookNow: {
            pt: 'Reservar Agora',
            en: 'Book Now'
        },
        consultConditions: {
            pt: '* Consulte condições em roady.pt',
            en: '* Consult conditions on roady.pt'
        },
        customReviewTitle: {
            pt: 'Revisão personalizada',
            en: 'Custom Review'
        },
        customReviewDescription: {
            pt: '• Óleo de Motor adquirido separadamente<br>• Mão de obra + Verificação<br>• Pontos de Controlo + Reposição<br>• Limpa Vidros',
            en: '• Motor Oil purchased separately<br>• Labor + Verification<br>• Control Points + Replacement<br>• Windshield Cleaner'
        },
        oilReviewIncludedTitle: {
            pt: 'Revisão com óleo incluído',
            en: 'Review with oil included'
        },
        oilReviewIncludedDescription: {
            pt: '• Mão de obra + Verificação<br>• Pontos de Controlo + Reposição<br>• Limpa Vidros<br>• Óleo incluído',
            en: '• Labor + Verification<br>• Control Points + Replacement<br>• Windshield Cleaner<br>• Oil included'
        },
        oilFilterIncludedTitle: {
            pt: 'Revisão com filtro de óleo incluído',
            en: 'Review with oil filter included'
        },
        oilFilterIncludedDescription: {
            pt: '• Mão de obra + Verificação<br>• Pontos de Controlo + Reposição<br>• Limpa Vidros<br>• Óleo + Filtro incluídos',
            en: '• Labor + Verification<br>• Control Points + Replacement<br>• Windshield Cleaner<br>• Oil + Filter included'
        },
        scheduleService: {
            pt: 'Peça orçamento',
            en: 'Request a Quote'
        },
        from: {
            pt: 'Desde',
            en: 'From'
        },
        viewOptions: {
            pt: 'Ver Opções',
            en: 'View Options'
        },
        priceOptions: {
            pt: 'Opções de Preço',
            en: 'Price Options'
        },
        customReviewOptionsTitle: {
            pt: 'Revisão Personalizada - Opções',
            en: 'Custom Review - Options'
        },
        oilReviewOptionsTitle: {
            pt: 'Revisão com Óleo - Opções',
            en: 'Oil Review - Options'
        },
        oilFilterReviewOptionsTitle: {
            pt: 'Revisão com Óleo + Filtro - Opções',
            en: 'Oil Review + Filter - Options'
        },
        optionWithoutFilter: {
            pt: 'Sem filtro',
            en: 'Without filter'
        },
        optionWithFilter: {
            pt: 'Com Filtro',
            en: 'With Filter'
        },
        option10W40: {
            pt: '10W40',
            en: '10W40'
        },
        optionOil10W40: {
            pt: 'Óleo 10W40',
            en: '10W40 Oil'
        },
        optionOilCEPSA10W40: {
            pt: 'Óleo CEPSA 10W40',
            en: 'CEPSA 10W40 Oil'
        },
        optionOilCEPSA5W40: {
            pt: 'Óleo CEPSA 5W40',
            en: 'CEPSA 5W40 Oil'
        },
        optionOilCEPSA5W30: {
            pt: 'Óleo CEPSA 5W30',
            en: 'CEPSA 5W30 Oil'
        },
        optionOilCASTROL5W30: {
            pt: 'Óleo CASTROL 5W30',
            en: 'CASTROL 5W30 Oil'
        },
        filterTooltip: {
            pt: '²A mão de obra não inclui a desmontagem de resguardos, se necessário. Inclui até 5 litros de óleo por veículo. Outras peças necessárias à realização das intervenções não incluídas. Os preços desta tabela incluem IVA à taxa legal em vigor e são válidos, salvo rutura de stock.',
            en: '²Labor does not include the removal of protective covers, if necessary. Includes up to 5 liters of oil per vehicle. Other parts necessary for the interventions are not included. The prices in this table include VAT at the current legal rate and are valid, subject to stock availability.'
        },
        controlPointsTooltip: {
            pt: '¹Pontos de Controlo: Líquido de travões, Óleo de Direção, Líquido Bateria, Líquido Refrigeração, Pressão de Pneus, Iluminação Exterior, Escovas Limpa Vidros, Funcionamento do Lava Vidros, Linha de Escape (sem coletor), Desgaste dos Pneus, Estado das Placas de Matrícula, Fugas Óleo de Motor, Fugas Óleo Transmissão , Fugas Óleo Direção, Cabos Juntos à Bateria, Terminais de Bateria, Reset da Revisão/Manutenção (desde que possível com o equipamento disponível no Centro-auto).',
            en: '¹Control Points: Brake fluid, Power steering oil, Battery fluid, Cooling fluid, Tire pressure, Exterior lighting, Windshield wipers, Windshield washer function, Exhaust line (without collector), Tire wear, License plate condition, Motor oil leaks, Transmission oil leaks, Power steering oil leaks, Battery cables, Battery terminals, Service/Maintenance reset (when possible with equipment available at the Auto Center).'
        },
        customReviewTitleBold: {
            pt: 'REVISÃO PERSONALIZADA',
            en: 'CUSTOM REVIEW'
        },
        oilReviewTitleBold: {
            pt: 'REVISÃO COM ÓLEO',
            en: 'OIL REVIEW'
        },
        oilFilterReviewTitleBold: {
            pt: 'REVISÃO COM ÓLEO + FILTRO',
            en: 'OIL REVIEW + FILTER'
        },
        motorOilPurchasedSeparately: {
            pt: 'Óleo de Motor adquirido separadamente',
            en: 'Motor Oil purchased separately'
        },
        controlPoints: {
            pt: 'Pontos de Controlo',
            en: 'Control Points'
        },
        windowCleanerReplacement: {
            pt: 'Limpa Vidros (Reposição)',
            en: 'Windshield Cleaner (Replacement)'
        },
        oilOnly: {
            pt: 'Óleo',
            en: 'Oil'
        },
        oilFilterIncludedText: {
            pt: 'Óleo + Filtro incluídos',
            en: 'Oil + Filter included'
        }
    },

    GALLERY: {
        followInstagram: {
            pt: 'Siga no Instagram',
            en: 'Follow Instagram'
        }
    },

    PRODUCT_DETAILS: {
        pageTitle: {
            pt: 'Detalhes do Produto',
            en: 'Product Details'
        },
        home: {
            pt: 'Início',
            en: 'Home'
        },
        store: {
            pt: 'Loja',
            en: 'Store'
        },
        loadingProduct: {
            pt: 'A carregar produto...',
            en: 'Loading product...'
        },
        loadingDescription: {
            pt: 'A carregar descrição do produto...',
            en: 'Loading product description...'
        },
        loadingCode: {
            pt: 'A carregar código do produto...',
            en: 'Loading product code...'
        },
        loadingDetails: {
            pt: 'A carregar detalhes do produto...',
            en: 'Loading product details...'
        },
        customerReviews: {
            pt: 'Avaliações de clientes',
            en: 'Customer reviews'
        },
        addToWishlist: {
            pt: 'Adicionar aos Favoritos',
            en: 'Add to Wishlist'
        },
        shareWithFriends: {
            pt: 'Partilhar com amigos:',
            en: 'Share with friends:'
        },
        description: {
            pt: 'Descrição',
            en: 'Description'
        },
        additionalInformation: {
            pt: 'Informações Adicionais',
            en: 'Additional information'
        },
        reviews: {
            pt: 'Avaliações',
            en: 'Reviews'
        },
        brand: {
            pt: 'Marca:',
            en: 'Brand:'
        },
        category: {
            pt: 'Categoria:',
            en: 'Category:'
        },
        code: {
            pt: 'Código:',
            en: 'Code:'
        },
        productReviews: {
            pt: 'Avaliações do Produto',
            en: 'Product Reviews'
        },
        noReviewsAvailable: {
            pt: 'Ainda não há avaliações disponíveis para este produto.',
            en: 'No reviews available for this product yet.'
        },
        productNotFound: {
            pt: 'Produto não encontrado',
            en: 'Product not found'
        },
        tryAgainLater: {
            pt: 'Por favor, tente novamente mais tarde ou volte à loja.',
            en: 'Please try again later or go back to the store.'
        },
        noDescriptionAvailable: {
            pt: 'Nenhuma descrição disponível',
            en: 'No description available'
        },
        noDetailedDescription: {
            pt: 'Nenhuma descrição detalhada disponível para este produto.',
            en: 'No detailed description available for this product.'
        },
        ref: {
            pt: 'REF.',
            en: 'REF.'
        },
        loading: {
            pt: 'A carregar...',
            en: 'Loading...'
        },
        productImage: {
            pt: 'Imagem do Produto',
            en: 'Product Image'
        }
    },

    CHAT: {
        title: {
            pt: 'Por favor, preencha o formulário abaixo e entraremos em contacto consigo o mais rapidamente possível.',
            en: 'Please fill out the form below and we will get back to you as soon as possible.'
        },
        namePlaceholder: {
            pt: 'O Seu Nome',
            en: 'Your Name'
        },
        emailPlaceholder: {
            pt: 'O Seu Email',
            en: 'Your Email'
        },
        messagePlaceholder: {
            pt: 'O Seu Texto',
            en: 'Your Text'
        },
        submitButton: {
            pt: 'Enviar Agora',
            en: 'Submit Now'
        },
        formTitle: {
            pt: 'Por favor, preencha o formulário abaixo e entraremos em contacto consigo o mais rapidamente possível.',
            en: 'Please fill out the form below and we will get back to you as soon as possible.'
        },
        yourText: {
            pt: 'O Seu Texto',
            en: 'Your Text'
        }
    },

    SIDEBAR: {
        aboutUs: {
            pt: 'Sobre Nós',
            en: 'About Us'
        },
        getQuote: {
            pt: 'Obtenha um orçamento gratuito',
            en: 'Get a free quote'
        },
        namePlaceholder: {
            pt: 'Nome',
            en: 'Name'
        },
        emailPlaceholder: {
            pt: 'Email',
            en: 'Email'
        },
        messagePlaceholder: {
            pt: 'Mensagem...',
            en: 'Message...'
        },
        submitButton: {
            pt: 'Enviar Agora',
            en: 'Submit Now'
        },
        contactInfo: {
            pt: 'Informações de Contacto',
            en: 'Contact Info'
        }
    },

    CUSTOMER_REVIEWS: {
        satisfied: {
            pt: 'Clientes Satisfeitos',
            en: 'Customer Satisfied'
        },
        reviews: {
            pt: '4.8 (15k Avaliações)',
            en: '4.8 (15k Reviews)'
        }
    },

    VIDEO: {
        title: {
            pt: 'Mãos profissionais, ferramentas especializadas e paixão pela perfeição.',
            en: 'Professional hands, expert tools, and passion for perfection.'
        },
        fromWornToWow: {
            pt: 'De Desgastado a Espetacular!',
            en: 'From Worn to Wow!'
        },
        watchHowWeBringLife: {
            pt: 'Veja Como Devolvemos a Vida ao <span>Seu Carro.</span>',
            en: 'Watch How We Bring Life Back To <span>Your Car.</span>'
        },
        professionalHandsExpertTools: {
            pt: 'Experiência, precisão e compromisso com o seu automóvel.',
            en: 'Experience, precision and commitment to your vehicle.'
        }
    },

    PROJECTS: {
        tagline: {
            pt: 'Projetos',
            en: 'Projects'
        }
    },

    BUTTONS: {
        discoverMore: {
            pt: 'Marcar Consulta',
            en: 'Book an Appointment'
        },
        requestQuote: {
            pt: 'Peça orçamento',
            en: 'Request a Quote'
        },
        budget: {
            pt: 'Orçamento',
            en: 'Budget'
        },
        selectService: {
            pt: 'Selecionar Serviço',
            en: 'Select Service'
        },
        contactUs: {
            pt: 'Contacte-nos',
            en: 'Contact Us'
        },
        whatsappButtonTooltip: {
            pt: 'Fale connosco',
            en: 'Contact Us'
        },
        goBackTop: {
            pt: 'Voltar ao Topo',
            en: 'Go Back Top'
        },
        contactHelpText: {
            pt: 'Se Precisar De Ajuda<br>Contacte-nos',
            en: 'If You Need Any Help<br>Contact With Us'
        },
        readMore: {
            pt: 'Ler Mais',
            en: 'Read More'
        },
        viewMore: {
            pt: 'Ver Mais',
            en: 'View More'
        },
        getStarted: {
            pt: 'Começar',
            en: 'Get Started'
        },
        callUsNow: {
            pt: 'Fale connosco',
            en: 'Call Us Now'
        },
        goBackToTop: {
            pt: 'Voltar ao topo',
            en: 'Go back to top'
        },
        goBack: {
            pt: 'Voltar',
            en: 'Go Back'
        },
        back: {
            pt: 'Voltar',
            en: 'Back'
        }
    },

    ALIGNMENT_SERVICE: {
        intro: {
            pt: 'O alinhamento incorreto causa desgaste irregular dos pneus e má condução do veículo, comprometendo a sua segurança.',
            en: 'Incorrect alignment causes uneven tire wear and poor vehicle handling, compromising your safety.'
        },
        description: {
            pt: 'O alinhamento, ou ajuste geométrico, posiciona as rodas do seu veículo paralelas entre si e à superfície da estrada.',
            en: 'Alignment, or geometric adjustment, positions your vehicle\'s wheels parallel to each other and the road surface.'
        },
        benefits: {
            pt: 'O alinhamento correto proporciona:',
            en: 'Proper alignment provides:'
        },
        benefit1: {
            pt: 'Melhor condução do veículo;',
            en: 'Better vehicle handling;'
        },
        benefit2: {
            pt: 'Desgaste uniforme dos pneus;',
            en: 'Even tire tread wear;'
        },
        benefit3: {
            pt: 'Poupança de combustível;',
            en: 'Fuel savings;'
        },
        recommendation: {
            pt: 'Recomendamos visitar um Centro Auto Roady para verificar o estado dos pneus e realizar o alinhamento correto pelo menos a cada inspeção do veículo.',
            en: 'We recommend visiting an Auto Roady Center to check tire condition and perform proper alignment at least every vehicle inspection.'
        }
    },

    DIAGNOSTIC_TEST_SERVICE: {
        intro: {
            pt: 'Os veículos, como as pessoas, podem parecer estar em boa saúde... quando não estão!',
            en: 'Vehicles, like people, can appear to be in good health… when they aren\'t!'
        },
        description: {
            pt: 'O teste diagnóstico é um exame rigoroso realizado para detetar anomalias do veículo.',
            en: 'Diagnostic testing is a rigorous examination performed to detect vehicle anomalies.'
        },
        benefits: {
            pt: 'O diagnóstico fornece informações abrangentes sobre a resolução de problemas dos sistemas de gestão do motor, gasolina e diesel, bem como dos sistemas de travagem e conforto dos veículos ligeiros.',
            en: 'Diagnostics provides comprehensive information on troubleshooting the engine, gasoline, and diesel management systems, as well as the braking and comfort systems of light vehicles.'
        },
        recommendation: {
            pt: 'Nos Centros Auto Roady, técnicos certificados aconselham e resolvem estas anomalias realizando um teste diagnóstico, evitando reparações mais dispendiosas no futuro.',
            en: 'At Auto Roady Centers, certified technicians advise and resolve these anomalies by performing a diagnostic test, avoiding more costly repairs in the future.'
        }
    },

    ROADY_REVIEW_SERVICE: {
        intro: {
            pt: 'Os serviços de manutenção Roady são uma solução eficaz e segura para garantir que o seu veículo está sempre em perfeito funcionamento.',
            en: 'Roady maintenance services are an effective and safe solution to ensure your vehicle is always in perfect working order.'
        },
        description: {
            pt: 'Por isso criámos os Serviços de Manutenção Roady.',
            en: 'That\'s why we created Roady Maintenance Services.'
        },
        benefits: {
            pt: 'São perfeitamente adaptados às necessidades do seu veículo, tendo em conta a quilometragem e a idade.',
            en: 'They are perfectly tailored to your vehicle\'s needs, taking into account mileage and age.'
        },
        oil: {
            pt: 'Para estes Serviços de Manutenção, pode escolher o óleo da sua preferência ou o óleo recomendado pelo fabricante.',
            en: 'For these Maintenance Services, you can choose the oil of your choice or the oil recommended by the manufacturer.'
        },
        prevention: {
            pt: 'Não se esqueça: Os Serviços de Manutenção Regulares previnem avarias potenciais e prolongam a vida do seu veículo.',
            en: 'Don\'t forget: Regular Maintenance Services prevent potential breakdowns and extend the life of your vehicle.'
        },
        availability: {
            pt: '* Verificar disponibilidade no Centro Auto Roady Oliveira de Azeméis',
            en: '* Check availability at Centro Auto Roady Oliveira de Azeméis'
        }
    },

    SHOCK_ABSORBERS_SERVICE: {
        intro: {
            pt: 'Nunca deve querer menos controlo e capacidade do que o seu veículo tinha quando era novo.',
            en: 'You should never want less control and capability than your vehicle had when it was new.'
        },
        description: {
            pt: 'A estabilidade de um veículo significa que está pronto para parar, virar e direcionar no momento exato e necessidade. Os amortecedores e molas reagem a cada movimento do corpo e direção, a cada solavanco e cada curva.',
            en: 'A vehicle\'s stability means it\'s ready to stop, turn, and steer at the exact moment and need. Shock absorbers and springs react to every body and steering movement, to every bump and every curve.'
        },
        function: {
            pt: 'Os amortecedores mantêm o veículo estável e mantêm-no no controlo. À medida que se desgastam, o seu veículo começa a inclinar, direcionar, balançar, tremer e reagir em excesso. Isto resulta numa capacidade de travagem reduzida e desgaste dos pneus e componentes.',
            en: 'Shock absorbers keep the vehicle stable and keep you in control. As they wear, your vehicle begins to lean, steer, sway, shake, and overreact. This results in reduced braking capacity and tire and component wear.'
        },
        replacement: {
            pt: 'Sim. Os amortecedores são peças de manutenção. À medida que se desgastam, o seu desempenho diminui.',
            en: 'Yes. Shock absorbers are maintenance parts. As they wear, their performance decreases.'
        },
        failures: {
            pt: 'As falhas dos amortecedores podem causar:',
            en: 'Shock absorber failures can cause:'
        },
        failure1: {
            pt: 'Fugas de fluido hidráulico;',
            en: 'Hydraulic fluid leaks;'
        },
        failure2: {
            pt: 'Desgaste dos pneus;',
            en: 'Tire wear;'
        },
        failure3: {
            pt: 'Condições de condução inseguras;',
            en: 'Unsafe driving conditions;'
        },
        failure4: {
            pt: 'Ruídos de batida e chocalho;',
            en: 'Knocking and rattling noises;'
        },
        failure5: {
            pt: 'Desvio do veículo, exigindo correções de direção durante a condução.',
            en: 'Vehicle swerving, requiring steering corrections while driving.'
        },
        when: {
            pt: 'Aos 80.000 km, a maioria dos amortecedores já não proporciona o controlo e manuseio de que o seu veículo é capaz.',
            en: 'At 80,000 km, most shock absorbers no longer provide the control and handling your vehicle is capable of.'
        },
        benefits: {
            pt: 'Substituir os seus amortecedores manterá o seu veículo a conduzir como novo. Restaurar o desempenho ajudará o seu veículo a durar mais tempo, poupar-lhe dinheiro e reduzir os custos de reparação futuros.',
            en: 'Replacing your shock absorbers will keep your vehicle driving like new. Restoring performance will help your vehicle last longer, save you money, and reduce future repair costs.'
        },
        recommendation: {
            pt: 'Certifique-se de visitar um dos Centros Auto Roady, abertos sete dias por semana, incluindo domingos e feriados, onde técnicos certificados podem aconselhar e resolver estas questões.',
            en: 'Be sure to visit one of the Auto Roady Centers, open seven days a week, including Sundays and holidays, where certified technicians can advise and resolve these issues.'
        }
    },

    INSPECTION_SERVICE: {
        intro: {
            pt: 'Uma inspeção periódica garante que o veículo está em bom estado de funcionamento e seguro, tornando-a essencial.',
            en: 'A periodic inspection ensures that the vehicle is in good working order and safe, making it essential.'
        },
        description: {
            pt: 'Deve ser concluída até à data e mês do registo inicial do veículo.',
            en: 'It must be completed by the date and month of the vehicle\'s initial registration.'
        },
        advantages: {
            pt: 'Vantagens:',
            en: 'Advantages:'
        },
        preInspection: {
            pt: 'Realizar um teste de pré-inspeção no veículo antes de o levar para inspeção permite a deteção precoce de anomalias, tais como:',
            en: 'Performing a pre-inspection test on the vehicle before taking it for inspection allows for early detection of anomalies, such as:'
        },
        anomaly1: {
            pt: 'Emissões poluentes que excedem o nível legalmente permitido;',
            en: 'Pollutant emissions exceeding the legally permitted level;'
        },
        anomaly2: {
            pt: 'Cintos de segurança em mau estado ou com mau funcionamento;',
            en: 'Seat belts in poor condition or malfunctioning;'
        },
        anomaly3: {
            pt: 'Análise de Gases de Escape;',
            en: 'Exhaust Gas Analysis;'
        },
        anomaly4: {
            pt: 'Pneus com desgaste que excede o nível legalmente permitido ou de tipo diferente por eixo;',
            en: 'Tires with wear exceeding the legally permitted level or of a different type per axle;'
        },
        anomaly5: {
            pt: 'Suspensão defeituosa (amortecedores ineficientes ou fugas de óleo);',
            en: 'Defective suspension (inefficient shock absorbers or oil leaks);'
        },
        anomaly6: {
            pt: 'Entre outros.',
            en: 'Among others.'
        },
        recommendation: {
            pt: 'Antes de cada inspeção, visite um dos nossos Centros Auto Roady. Os nossos técnicos certificados aconselharão e resolverão estas anomalias realizando um teste de pré-inspeção, evitando reparações mais dispendiosas no futuro.',
            en: 'Before each inspection, visit one of our Auto Roady Centers. Our certified technicians will advise you and resolve these anomalies by performing a pre-inspection test, avoiding more costly repairs in the future.'
        }
    },

    GENERAL_MECHANICS_SERVICE: {
        intro: {
            pt: 'Nos nossos Centros Auto Roady, pode desfrutar de serviços especializados. Utilizamos a mais recente tecnologia e oferecemos uma gama de serviços destinados a manter e reparar o seu veículo.',
            en: 'At our Auto Roady Centers, you can enjoy specialized services. We utilize the latest technology and offer a range of services aimed at maintaining and repairing your vehicle.'
        },
        team: {
            pt: 'A nossa equipa especializada está preparada para todos os serviços mecânicos gerais multi-marca, desde mudanças de óleo até reparações importantes. Estamos disponíveis 24/7 para fornecer conselhos personalizados.',
            en: 'Our specialized team is prepared for all multi-brand general mechanical services, from oil changes to major repairs. We are available 24/7 to provide personalized advice.'
        },
        services: {
            pt: 'Reparamos e mantemos o seu veículo:',
            en: 'We repair and maintain your vehicle:'
        },
        service1: {
            pt: 'Substituição do kit de distribuição;',
            en: 'Timing kit replacement;'
        },
        service2: {
            pt: 'Transmissões e direção;',
            en: 'Transmissions and steering;'
        },
        service3: {
            pt: 'Embreagens;',
            en: 'Clutches;'
        },
        service4: {
            pt: 'Travões;',
            en: 'Brakes;'
        },
        service5: {
            pt: 'Amortecedores;',
            en: 'Shock absorbers;'
        },
        service6: {
            pt: 'Diagnósticos atualizados para as mais recentes gerações de veículos;',
            en: 'Updated diagnostics for the latest vehicle generations;'
        },
        recommendation: {
            pt: 'Verifique sempre as condições de segurança do seu veículo; certifique-se de visitar um dos nossos Centros Auto Roady.',
            en: 'Always check your vehicle\'s safety conditions; be sure to visit one of our Auto Roady Centers.'
        }
    },

    WORKSHOP_SERVICES_PACK: {
        brakePack: {
            pt: 'Serviço Pack Travões.',
            en: 'Brake Pack Service.'
        },
        brakePackDesc: {
            pt: 'Preços válidos para a compra e instalação de peças no Centro Auto Roady Oliveira de Azeméis e para peças em stock. As peças não podem ser vendidas abaixo do preço de custo. *Preços válidos para o eixo dianteiro ou traseiro. Luzes de aviso de desgaste não incluídas.',
            en: 'Prices valid for the purchase and installation of parts at the Oliveira de Azeméis Roady Auto Center and for in-stock parts. Parts cannot be sold below cost price. *Prices valid for the front or rear axle. Wear warning lights not included.'
        },
        timingBelt: {
            pt: 'Serviço Pack Correia de Distribuição.',
            en: 'Timing Belt Pack Service.'
        },
        timingBeltDesc: {
            pt: '*Preço válido para a compra e instalação de peças no Centro Auto Roady Oliveira de Azeméis. As peças não podem ser vendidas abaixo do preço de custo. Pacote válido para veículos apenas com correia de distribuição. Bomba de água com componentes elétricos não incluída (preço mediante consulta).',
            en: '*Price valid for the purchase and installation of parts at the Oliveira de Azeméis Roady Auto Center. Parts cannot be sold below cost price. Package valid for vehicles with only a timing belt. Water pump with electrical components not included (price upon request).'
        }
    },

    AIR_CONDITIONING_SERVICE: {
        intro: {
            pt: 'Desenvolvido especificamente para o conforto do utilizador, o ar condicionado regula a temperatura interna do ambiente, reduzindo o impacto do calor.',
            en: 'Developed specifically for user comfort, air conditioning regulates the internal temperature of the environment, reducing the impact of heat.'
        },
        recommendation: {
            pt: 'O Centro Auto Roady recomenda uma visita às nossas instalações, onde pode ter o ar condicionado do seu veículo servido pelos nossos técnicos especializados.',
            en: 'Auto Roady Center recommends a visit to our facilities, where you can have your vehicle\'s air conditioning serviced by our specialized technicians.'
        },
        advantages: {
            pt: 'Vantagens:',
            en: 'Advantages:'
        },
        advantage1: {
            pt: 'Melhora a qualidade do ar no interior do veículo;',
            en: 'Improves the air quality inside the vehicle;'
        },
        advantage2: {
            pt: 'Garante uma temperatura agradável seja verão ou inverno, tornando a condução mais confortável e segura;',
            en: 'Ensures a pleasant temperature whether summer or winter, making driving more comfortable and safe;'
        },
        advantage3: {
            pt: 'Previne o embaciamento das janelas;',
            en: 'Prevents fogging of the windows;'
        },
        advantage4: {
            pt: 'Reduz os odores no interior do veículo.',
            en: 'Reduces odors inside the vehicle.'
        },
        check: {
            pt: 'Sabia que deve verificar o seu sistema de ar condicionado todos os anos e mudar o filtro de ar condicionado de três em três anos?',
            en: 'Did you know you should check your air conditioning system every year and change the air conditioning filter every three years?'
        },
        service: {
            pt: 'Num dos nossos Centros Auto Roady, pode carregar o ar condicionado do seu veículo. O serviço de carregamento de ar condicionado numa das nossas oficinas inclui:',
            en: 'At one of our Auto Roady Centers, you can charge your vehicle\'s air conditioning. The air conditioning charging service at one of our workshops includes:'
        },
        service1: {
            pt: 'Controlo da temperatura da cabine;',
            en: 'Cabin temperature control;'
        },
        service2: {
            pt: 'Aspiração do circuito de ar condicionado;',
            en: 'Vacuuming the air conditioning circuit;'
        },
        warning: {
            pt: 'Evite ligar e desligar o veículo com o ar condicionado ligado. Isto pode aumentar o risco de danos no compressor, encurtando a vida útil do equipamento.',
            en: 'Avoid turning the vehicle on and off with the air conditioning on. This can increase the risk of compressor damage, shortening the lifespan of the equipment.'
        },
        fuel: {
            pt: 'Independentemente do tipo de combustível que o seu veículo utiliza, ligar o ar condicionado não aumenta significativamente o consumo de combustível. Conduzir com as janelas abertas na autoestrada pode fazer com que use mais combustível do que usar o ar condicionado.',
            en: 'Regardless of the fuel type your vehicle uses, turning on the air conditioning doesn\'t significantly increase fuel consumption. Driving with the windows open on the highway can cause you to use more fuel than using the air conditioning.'
        }
    },

    HEADLIGHT_RESTORATION_SERVICE: {
        intro: {
            pt: 'Tem a certeza de que o seu carro ilumina bem a estrada?',
            en: 'Are you sure your car illuminates the road well?'
        },
        call: {
            pt: 'Visite um dos nossos centros Roady e restaure a visibilidade total à sua condução!',
            en: 'Visit one of our Roady centers and restore full visibility to your driving!'
        },
        check: {
            pt: 'Verifique as condições no nosso Centro Auto Roady.',
            en: 'Check the conditions at our Roady Auto Center.'
        }
    },

    BATTERY_SERVICE: {
        intro: {
            pt: 'A bateria é um dos componentes mais fundamentais num carro. A sua função é fornecer toda a energia que alimenta o motor e vários sistemas eletrónicos. Quando esta função já não é cumprida, o carro não se move.',
            en: 'The battery is one of the most fundamental components in a car. Its function is to provide all the energy that powers the engine and various electronic systems. When this function is no longer fulfilled, the car won\'t move.'
        },
        technology: {
            pt: 'Além disso, com o avanço da tecnologia, todos os acessórios do carro dependem cada vez mais desta fonte de energia para funcionar corretamente.',
            en: 'Furthermore, as technology advances, all car accessories increasingly rely on this power source to function properly.'
        },
        service: {
            pt: 'Se a sua bateria estiver descarregada, vamos ter consigo onde quer que esteja, contacte o nosso Centro Auto Roady.',
            en: 'If your battery is dead, we\'ll come to you wherever you are, contact our Auto Roady Center.'
        },
        hours: {
            pt: 'Aberto sete dias por semana, incluindo domingos e feriados.',
            en: 'Open seven days a week, including Sundays and holidays.'
        },
        services: {
            pt: 'Serviço de substituição de bateria e/ou inspeção do circuito de carregamento | Recarga de bateria.',
            en: 'Battery replacement and/or charging circuit inspection service | Battery recharge.'
        }
    },

    BRAKE_SERVICE: {
        intro: {
            pt: 'O sistema de travagem é um elemento extremamente importante para a segurança do seu veículo. Bons travões podem fazer toda a diferença em caso de perigo iminente. A sua manutenção não deve ser negligenciada ou ignorada; certifique-se de visitar um dos nossos Centros Auto Roady.',
            en: 'The braking system is an extremely important element for your vehicle\'s safety. Good brakes can make all the difference in the event of imminent danger. Their maintenance should not be neglected or ignored; be sure to visit one of our Auto Roady Centers.'
        },
        fluidService: {
            pt: 'Serviço de Mudança de Fluido de Travões.',
            en: 'Brake Fluid Change Service.'
        },
        fluidDescription: {
            pt: 'Manter o fluido de travões em boas condições ajuda a manter o sistema de travagem, um elemento essencial para a segurança do veículo.',
            en: 'Maintaining brake fluid in good condition helps maintain the braking system, an essential element for vehicle safety.'
        },
        fluidRecommendation: {
            pt: 'Os fabricantes recomendam mudar o fluido de travões de dois em dois anos; no entanto, se os travões estiverem sujeitos a uso intenso, a mudança deve ser feita mais cedo.',
            en: 'Manufacturers recommend changing brake fluid every two years; however, if the brakes are subject to heavy use, the change should be done sooner.'
        }
    },

    WASHING_SERVICE: {
        intro: {
            pt: 'O nosso centro de lavagem automóvel self-service oferece aos clientes uma forma conveniente e acessível de limpar os seus veículos.',
            en: 'Our self-service car wash center offers customers a convenient and affordable way to clean their vehicles.'
        },
        facilities: {
            pt: 'Com instalações de última geração e equipamento de qualidade, os clientes podem lavar os seus carros de forma fácil, segura e eficiente.',
            en: 'With state-of-the-art facilities and quality equipment, customers can wash their cars easily, safely, and efficiently.'
        },
        system: {
            pt: 'O nosso sistema self-service permite aos clientes controlar o processo de lavagem escolhendo programas de lavagem, tempo e quantidade de água utilizada. Além disso, o pessoal do Centro Auto Roady está sempre pronto para ajudar e garantir que os clientes tenham uma experiência agradável e satisfatória!',
            en: 'Our self-service system allows customers to control the wash process by choosing wash programs, time, and amount of water used. Furthermore, the Roady Auto Center staff is always ready to help and ensure customers have a pleasant and satisfying experience!'
        },
        perfect: {
            pt: 'O nosso centro de lavagem automóvel self-service é a escolha perfeita para quem procura um serviço de limpeza de veículos de qualidade.',
            en: 'Our self-service car wash center is the perfect choice for those seeking a quality vehicle cleaning service.'
        },
        professional: {
            pt: 'Também oferecemos serviços de limpeza profissional para clientes que desejam uma limpeza mais completa e profunda do seu veículo.',
            en: 'We also offer professional cleaning services for customers who desire a more thorough and deep clean of their vehicle.'
        },
        team: {
            pt: 'Os nossos profissionais altamente qualificados e experientes estão prontos para realizar serviços de limpeza que incluem lavagem, polimento e limpeza de estofos.',
            en: 'Our highly qualified and experienced professionals are ready to perform cleaning services that include washing, polishing, and upholstery cleaning.'
        },
        welcome: {
            pt: 'Esperamos vê-lo!',
            en: 'We look forward to seeing you!'
        }
    },

    CONTACT: {
        location: {
            pt: 'Localização:',
            en: 'Location:'
        },
        address: {
            pt: 'Centro Auto Roady Oliveira de Azeméis<br>Av. D. Maria I - Lugar de Aldas, 3720-300 Oliveira de Azeméis',
            en: 'Centro Auto Roady Oliveira de Azeméis<br>Av. D. Maria I - Lugar de Aldas, 3720-300 Oliveira de Azeméis'
        },
        phoneCallInfo: {
            pt: 'Chamada para a rede fixa nacional',
            en: 'Call to national landline'
        },
        hours: {
            pt: 'Horário de Funcionamento:',
            en: 'Opening Hours:'
        },
        schedule: {
            pt: 'Seg - Sáb: 8:30 - 19:00<br>Dom: 9:00 - 13:00',
            en: 'Mon - Sat: 8:30 AM - 7:00 PM<br>Sun: 9:00 AM - 1:00 PM'
        },
        helpText: {
            pt: 'Precisa de Ajuda?<br>Fale Connosco',
            en: 'If You Need Any Help<br>Contact With Us'
        },
        phone: {
            pt: 'Telefone:',
            en: 'Phone Call:'
        },
        number: {
            pt: '(+351) 256 665 200',
            en: '(+351) 256 665 200'
        }
    },

    FOOTER: {
        about: {
            pt: 'Serviços automóveis profissionais com técnicos certificados e equipamento de qualidade.',
            en: 'Professional automotive services with certified technicians and quality equipment.'
        },
        aboutText: {
            pt: 'Auto Roady Oliveira de Azeméis é o seu centro de serviços automóveis de confiança, fornecendo serviços abrangentes de manutenção, reparação e diagnóstico de automóveis. Com técnicos certificados e equipamento de última geração, garantimos que o seu veículo recebe o melhor cuidado possível.',
            en: 'Auto Roady Oliveira de Azeméis is your trusted automotive service center, providing comprehensive car maintenance, repair, and diagnostic services. With certified technicians and state-of-the-art equipment, we ensure your vehicle receives the best care possible.'
        },
        footerAboutText: {
            pt: 'O Roady Centro-Auto Oliveira de Azeméis é um centro automóvel especializado em manutenção, reparação e diagnóstico de veículos. Disponibilizamos serviços completos — desde motor, embraiagem e suspensão até alinhamento, travões, revisões, lavagem e ar condicionado.',
            en: 'Roady Centro-Auto Oliveira de Azeméis is a specialized automotive center in vehicle maintenance, repair and diagnosis. We provide complete services — from engine, clutch and suspension to alignment, brakes, reviews, washing and air conditioning.'
        },
        quickLinks: {
            pt: 'Links Rápidos',
            en: 'Quick Links'
        },
        footerQuickLinks: {
            pt: 'Links Rápidos',
            en: 'Quick Links'
        },
        team: {
            pt: 'A Nossa Equipa',
            en: 'Our Team'
        },
        pricing: {
            pt: 'Os Nossos Preços',
            en: 'Our Pricing'
        },
        appointment: {
            pt: 'Orçamento',
            en: 'Quote'
        },
        contact: {
            pt: 'Contacte-nos',
            en: 'Contact Us'
        },
        ourServices: {
            pt: 'Os Nossos Serviços',
            en: 'Our Services'
        },
        footerOurServices: {
            pt: 'Os Nossos Serviços',
            en: 'Our Services'
        },
        contactInfo: {
            pt: 'Informações de Contacto',
            en: 'Contact Info'
        },
        footerContactInfo: {
            pt: 'Contacto',
            en: 'Contact'
        },
        location: {
            pt: 'Localização:',
            en: 'Location:'
        },
        footerLocation: {
            pt: 'Localização:',
            en: 'Location:'
        },
        openingHours: {
            pt: 'Horário de Funcionamento:',
            en: 'Opening Hours:'
        },
        footerOpeningHours: {
            pt: 'Horário',
            en: 'Hours'
        },
        footerHours: {
            pt: 'Seg - Sáb: 8:00 - 18:00<br>Dom: 9:00 - 13:00',
            en: 'Mon - Sat: 8:00 AM - 6:00 PM<br>Sun: 9:00 AM - 1:00 PM'
        },
        footerPhone: {
            pt: 'Telefone:',
            en: 'Phone:'
        },
        footerEmail: {
            pt: 'Email:',
            en: 'Email:'
        },
        email: {
            pt: 'Email:',
            en: 'Email:'
        },
        support: {
            pt: 'Suporte',
            en: 'Support'
        },
        terms: {
            pt: 'Termos e Condições',
            en: 'Terms & Conditions'
        },
        footerTerms: {
            pt: 'Termos e Condições',
            en: 'Terms & Conditions'
        },
        privacy: {
            pt: 'Política de Privacidade',
            en: 'Privacy Policy'
        },
        footerPrivacy: {
            pt: 'Política de Privacidade',
            en: 'Privacy Policy'
        },
        footerCookies: {
            pt: 'Cookies',
            en: 'Cookies'
        },
        footerCookieSettings: {
            pt: 'Definições de Cookies',
            en: 'Cookie Settings'
        },
        footerAiNotice: {
            pt: 'Algumas imagens deste website foram criadas ou editadas com recurso a inteligência artificial, para fins ilustrativos. Mais informação nos',
            en: 'Some images on this website were created or edited using artificial intelligence, for illustrative purposes. More information in our'
        },
        footerAiNoticeLink: {
            pt: 'Termos e Condições',
            en: 'Terms and Conditions'
        },
        copyright: {
            pt: '© Copyright 2025 por Roady Oliveira de Azeméis. Todos os Direitos Reservados.',
            en: '© Copyright 2025 by Roady Oliveira de Azeméis. All Rights Reserved.'
        },
        developedBy: {
            pt: 'Desenvolvido por',
            en: 'Developed by'
        },
        footerDevelopedBy: {
            pt: 'Desenvolvido por',
            en: 'Developed by'
        },
        developedByMyouweb: {
            pt: 'Desenvolvido por Myouweb | 2025',
            en: 'Developed by Myouweb | 2025'
        }
    },

    CTA: {
        title: {
            pt: 'Subscreva para Qualquer Informação de Atualização',
            en: 'Subscribe for Any Update Information'
        },
        subscribe: {
            pt: 'Subscreva-nos',
            en: 'Subscribe Us'
        }
    },

    FAQ: {
        commonQuestions: {
            pt: 'Perguntas Frequentes',
            en: 'Common Questions'
        },
        findAnswersToCommon: {
            pt: 'Perguntas Frequentes <br class="mobile-only" /><span>sobre a Oficina Roady Oliveira de Azeméis</span>',
            en: 'Frequently Asked Questions <span>about the Roady Oliveira de Azeméis Workshop</span>'
        },
        question1: {
            pt: 'O Roady Centro-Auto é apenas oficina ou também tem loja?',
            en: 'Is Roady Centro-Auto only a workshop, or does it also have a store?'
        },
        answer1: {
            pt: 'O Roady é simultaneamente loja especializada e oficina automóvel. Para além dos serviços de manutenção e reparação, dispõe de uma loja com uma oferta abrangente de equipamentos, peças e acessórios automóveis. Os clientes encontram soluções como peças e consumíveis, baterias, equipamentos de interior e exterior, tapetes, estofos e acessórios de conforto, bagageiras e malas de tejadilho, ferramentas, produtos de manutenção, bem como acessórios de viagem e segurança.',
            en: 'Roady Centro-Auto is both a specialised automotive workshop and a retail store. In addition to maintenance and repair services, it offers a wide range of automotive equipment, parts, and accessories. Customers can find products such as parts and consumables, batteries, interior and exterior equipment, mats, seat covers and comfort accessories, roof boxes and luggage solutions, tools, maintenance products, as well as travel and safety accessories.'
        },
        question2: {
            pt: 'Fazem revisões oficiais de acordo com a marca do veículo?',
            en: 'Do you carry out official services according to the vehicle manufacturer?'
        },
        answer2: {
            pt: 'Sim. As revisões são realizadas de acordo com o plano de manutenção definido pelo fabricante, respeitando as especificações técnicas da marca e utilizando procedimentos adequados, salvaguardando a garantia do veículo.',
            en: 'Yes. Services are carried out in accordance with the maintenance plan defined by the manufacturer, respecting the brand\'s technical specifications and using appropriate procedures, while safeguarding the vehicle\'s warranty.'
        },
        question3: {
            pt: 'É possível realizar um check-up para avaliar a necessidade de substituição de componentes?',
            en: 'Is it possible to carry out a check-up to assess the need for component replacement?'
        },
        answer3: {
            pt: 'Sim. É possível realizar check-ups de verificação que permitem avaliar o estado geral de vários componentes do veículo, identificando desgaste ou necessidade de substituição. Com base nessa avaliação, é feito um aconselhamento técnico claro e transparente, permitindo ao cliente decidir de forma informada sobre as intervenções a realizar.',
            en: 'Yes. Check-ups can be carried out to assess the overall condition of various vehicle components, identifying wear or the need for replacement. Based on this assessment, clear and transparent technical advice is provided, allowing the customer to make an informed decision about any necessary interventions.'
        },
        question4: {
            pt: 'Existem serviços rápidos e outros que podem demorar mais tempo?',
            en: 'Are there quick services and others that may take longer?'
        },
        answer4: {
            pt: 'Sim. Alguns serviços de manutenção são, regra geral, mais rápidos e podem ser realizados no próprio dia, como a substituição de pneus (com uma vasta gama disponível em loja), intervenções em travões, baterias ou outros serviços de manutenção corrente. Já noutros casos, nomeadamente quando existem avarias no motor, falhas de funcionamento ou situações em que a origem do problema não é imediatamente identificável, o processo pode exigir um diagnóstico mais aprofundado e, posteriormente, uma intervenção técnica mais demorada. Em todas as situações, o estado do veículo, o diagnóstico, os prazos previstos e as intervenções necessárias são sempre comunicados de forma clara ao cliente, sendo qualquer reparação efetuada apenas após aprovação.',
            en: 'Yes. Some maintenance services are generally quicker and can often be carried out on the same day, such as tyre replacement (with a wide range available in store), brake work, battery replacement, or other routine maintenance services. In other cases, particularly when there are engine issues, operational faults, or situations where the cause of the problem is not immediately identifiable, a more in-depth diagnosis may be required, followed by a more time-consuming repair. In all situations, the vehicle\'s condition, diagnosis, estimated timeframes, and required interventions are clearly communicated to the customer, and any repair is carried out only after approval.'
        },
        question5: {
            pt: 'Têm serviços de manutenção para frotas automóveis?',
            en: 'Do you provide maintenance services for vehicle fleets?'
        },
        answer5: {
            pt: 'Sim. Dispomos de soluções de manutenção e acompanhamento técnico para frotas automóveis, adaptadas a empresas, gestores de frota, renting e PME, com foco na otimização de custos, disponibilidade dos veículos e cumprimento dos planos de manutenção.',
            en: 'Yes. We offer maintenance and technical support solutions for vehicle fleets, tailored to companies, fleet managers, leasing and rental operators, and SMEs, with a focus on cost optimisation, vehicle availability, and compliance with maintenance plans.'
        },
        question6: {
            pt: 'A manutenção realizada no Roady interfere com a garantia do veículo?',
            en: 'Does maintenance carried out at Roady affect the vehicle\'s warranty?'
        },
        answer6: {
            pt: 'Não. Desde que a manutenção seja efetuada de acordo com as especificações do fabricante e com a utilização de peças adequadas, a garantia do veículo é salvaguardada, conforme a legislação em vigor.',
            en: 'No. As long as maintenance is carried out in accordance with the manufacturer\'s specifications and using suitable parts, the vehicle\'s warranty is preserved, in line with applicable legislation.'
        },
        andAllThoseQuestions: {
            pt: '(e todas essas perguntas)',
            en: '(and all those questions)'
        }
    },

    APPOINTMENT: {
        bookAppointment: {
            pt: 'Marcar Consulta',
            en: 'Book Appointment'
        },
        getInTouch: {
            pt: 'Fale Connosco',
            en: 'Contact Us'
        },
        description: {
            pt: 'Pronto para experimentar cuidados automóveis excecionais? Marque a sua consulta hoje e deixe os nossos técnicos certificados cuidar do seu veículo.',
            en: 'Ready to experience exceptional car care? Schedule your appointment today and let our certified technicians take care of your vehicle.'
        },
        yourName: {
            pt: 'O Seu Nome',
            en: 'Your Name'
        },
        yourEmail: {
            pt: 'O Seu Email',
            en: 'Your Email'
        },
        yourPhone: {
            pt: 'O Seu Telefone',
            en: 'Your Phone'
        },
        selectService: {
            pt: 'Selecionar Serviço',
            en: 'Select Service'
        },
        yourMessage: {
            pt: 'A Sua Mensagem',
            en: 'Your Message'
        },
        sendMessage: {
            pt: 'Enviar Mensagem',
            en: 'Send Message'
        },
        contactUsBtn: {
            pt: 'Fale Connosco',
            en: 'Contact Us'
        },
        bookNowAnAppointment: {
            pt: 'Marque Agora Uma Consulta',
            en: 'Book Now An Appointment'
        },
        appointmentNow: {
            pt: 'Marcar Agora',
            en: 'Appointment Now'
        },
        fullName: {
            pt: 'Nome Completo',
            en: 'Full Name'
        },
        emailAddress: {
            pt: 'Endereço de Email',
            en: 'Email Address'
        },
        phoneNumber: {
            pt: 'Número de Telefone',
            en: 'Phone Number'
        },
        appointmentDate: {
            pt: 'dd/mm/aaaa',
            en: 'mm/dd/yyy'
        },
        aboutUs: {
            pt: 'Sobre Nós',
            en: 'About Us'
        },
        getFreeQuote: {
            pt: 'Obtenha um orçamento gratuito',
            en: 'Get a free quote'
        },
        contactInfo: {
            pt: 'Informações de Contacto',
            en: 'Contact Info'
        },
        name: {
            pt: 'Nome',
            en: 'Name'
        },
        email: {
            pt: 'Email',
            en: 'Email'
        },
        message: {
            pt: 'Mensagem...',
            en: 'Message...'
        },
        submitNow: {
            pt: 'Enviar Agora',
            en: 'Submit Now'
        },
        pleaseWait: {
            pt: 'Por favor aguarde...',
            en: 'Please wait...'
        },
        getInTouchTagline: {
            pt: 'Fale Connosco',
            en: 'Contact Us'
        },
        contactUs: {
            pt: 'Fale Connosco',
            en: 'Contact Us'
        },
        privacyPolicyText: {
            pt: 'Aceito a <a href="/politica-privacidade" target="_blank">Política de Privacidade</a> e concordo com o tratamento dos meus dados pessoais *',
            en: 'I accept the <a href="/politica-privacidade" target="_blank">Privacy Policy</a> and agree to the processing of my personal data *'
        }
    },

    COOKIE_CONSENT: {
        preferences: {
            pt: 'Preferências de Cookies',
            en: 'Cookie Preferences'
        },
        description: {
            pt: 'Utilizamos cookies para melhorar a sua experiência de navegação, servir conteúdo personalizado e analisar o nosso tráfego. Ao clicar em "Aceitar Tudo", consente no uso dos nossos cookies.',
            en: 'We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.'
        },
        acceptAll: {
            pt: 'Aceitar Tudo',
            en: 'Accept All'
        },
        declineAll: {
            pt: 'Recusar Tudo',
            en: 'Decline All'
        },
        customize: {
            pt: 'Personalizar',
            en: 'Customize'
        },
        essentialCookies: {
            pt: 'Cookies Essenciais',
            en: 'Essential Cookies'
        },
        analyticsCookies: {
            pt: 'Cookies de Análise',
            en: 'Analytics Cookies'
        },
        marketingCookies: {
            pt: 'Cookies de Marketing',
            en: 'Marketing Cookies'
        },
        preferencesCookies: {
            pt: 'Cookies de Preferências',
            en: 'Preference Cookies'
        },
        savePreferences: {
            pt: 'Guardar Preferências',
            en: 'Save Preferences'
        },
        privacyPolicy: {
            pt: 'Política de Privacidade',
            en: 'Privacy Policy'
        },
        termsConditions: {
            pt: 'Termos e Condições',
            en: 'Terms & Conditions'
        },
        cookiePolicy: {
            pt: 'Política de Cookies',
            en: 'Cookie Policy'
        }
    },

    WISHLIST: {
        title: {
            pt: 'Lista de Desejos',
            en: 'Wishlist'
        },
        productName: {
            pt: 'Nome do Produto',
            en: 'Product Name'
        },
        brand: {
            pt: 'Marca',
            en: 'Brand'
        },
        stockStatus: {
            pt: 'Estado do Stock',
            en: 'Stock Status'
        },
        action: {
            pt: 'Ação',
            en: 'Action'
        },
        loading: {
            pt: 'A carregar lista de desejos...',
            en: 'Loading wishlist...'
        },
        emptyTitle: {
            pt: 'A sua lista de desejos está vazia',
            en: 'Your wishlist is empty'
        },
        emptyText: {
            pt: 'Adicione produtos à sua lista de desejos para os guardar para mais tarde.',
            en: 'Add products to your wishlist to save them for later.'
        },
        emptyButton: {
            pt: 'Ver Produtos',
            en: 'View Products'
        },
        seeProduct: {
            pt: 'Ver o Produto',
            en: 'See the Product'
        },
        inStock: {
            pt: 'Em Stock',
            en: 'In Stock'
        },
        outOfStock: {
            pt: 'Fora de Stock',
            en: 'Out of Stock'
        },
        selectProduct: {
            pt: 'Selecionar Produto',
            en: 'Select Product'
        }
    },

    STORE: {
        title: {
            pt: 'Loja',
            en: 'Store'
        },
        home: {
            pt: 'Início',
            en: 'Home'
        },
        search: {
            pt: 'Pesquisar',
            en: 'Search'
        },
        searchHere: {
            pt: 'Pesquisar Aqui',
            en: 'Search Here'
        },
        categories: {
            pt: 'Categorias',
            en: 'Categories'
        },
        allCategories: {
            pt: 'Todas as Categorias',
            en: 'All Categories'
        },
        loadingProducts: {
            pt: 'A carregar produtos...',
            en: 'Loading products...'
        },
        sortByPopular: {
            pt: 'Ordenar por popularidade',
            en: 'Sort by popular'
        },
        sortByName: {
            pt: 'Ordenar por nome',
            en: 'Sort by name'
        },
        sortByBrand: {
            pt: 'Ordenar por marca',
            en: 'Sort by brand'
        },
        brand: {
            pt: 'Marca',
            en: 'Brand'
        },
        category: {
            pt: 'Categoria',
            en: 'Category'
        },
        premiumQualityProducts: {
            pt: 'Produtos de<br>Qualidade Premium',
            en: 'Premium Quality<br>Products'
        },
        expertRecommendations: {
            pt: 'Recomendações<br>de Especialistas',
            en: 'Expert<br>Recommendations'
        },
        bestPricesGuaranteed: {
            pt: 'Melhores Preços<br>Garantidos',
            en: 'Best Prices<br>Guaranteed'
        },
        specialPromotions: {
            pt: 'Promoções<br>Especiais',
            en: 'Special<br>Promotions'
        },
        needHelpChoosing: {
            pt: 'Precisa de ajuda para escolher? Contacte os nossos Especialistas de Produtos',
            en: 'Need help choosing? Contact our Product Specialists'
        },
        expressOilChange: {
            pt: 'Mudança de óleo express',
            en: 'Express oil change'
        },
        productInformation: {
            pt: 'Informações do Produto',
            en: 'Product Information'
        },
        description: {
            pt: 'Descrição',
            en: 'Description'
        },
        viewDetails: {
            pt: 'Ver Detalhes',
            en: 'View Details'
        },
        addToWishlist: {
            pt: 'Adicionar aos Favoritos',
            en: 'Add to Wishlist'
        },
        noDescriptionAvailable: {
            pt: 'Nenhuma descrição disponível para este produto.',
            en: 'No description available for this product.'
        }
    },

    PAGE_TITLE: {
        title: {
            pt: 'Início || Roady Oliveira de Azeméis || Centro Auto Roady',
            en: 'Home One || Servixa || Servixa HTML 5 Template'
        }
    },

    ADDITIONAL: {
        yearsOfExperience: {
            pt: 'Anos de<br>Experiência',
            en: 'Years Of<br>Experience'
        },
        realResultsSpeak: {
            pt: 'Resultados reais que falam por si só veja a magia dos cuidados especializados Restaurado à Perfeição.',
            en: 'Real results that speak for themselves see the magic of expert care Restored to Perfection.'
        },
        insteadOfPursuing: {
            pt: 'Em vez de perseguir testes de primeira linha, mantenha colaboração de alto retorno e partilha de ideias globalmente após soluções virais levarem à quota de mercado. Serviço ao cliente profissional.',
            en: 'Instead of pursuing premier testing, sustain high-payoff collaboration and idea sharing globally after viral solutions lead to edge mindshare. Professional customer service.'
        },
        fullBodyRepair: {
            pt: 'Reparação completa da carroçaria e detalhamento feito',
            en: 'Full body repaire and detailing done'
        },
        dentRepaired: {
            pt: 'Amolgadela reparada e polida',
            en: 'Dent repaired and polished'
        },
        engineRepair: {
            pt: 'Motor Reparado e restaurado',
            en: 'Engine Repaire and restored'
        },
        exceptionalCarCare: {
            pt: 'Cuidados Automóveis Excecionais<br>Apoiados por Experiência,<br>Confiança e uma Paixão pela Perfeição.',
            en: 'Exceptional Car Care<br>Backed by Experience,<br>Trust, and a Passion for Perfection.'
        },
        expertCleaningDescription: {
            pt: 'Limpeza especializada com produtos ecológicos, planos personalizados, serviço confiável, limpadores treinados, preços transparentes e garantia de satisfação de 100%.',
            en: 'Expert cleaning with eco-friendly products, customized plans, reliable service, trained cleaners, transparent pricing, and a 100% satisfaction guarantee.'
        }
    },

    ADMIN: {
        title: {
            pt: 'Admin | Roady',
            en: 'Admin | Roady'
        },
        brand: {
            pt: 'Roady Admin',
            en: 'Roady Admin'
        },
        nav: {
            dashboard: {
                pt: 'Painel',
                en: 'Dashboard'
            },
            products: {
                pt: 'Produtos',
                en: 'Products'
            },
            catalog: {
                pt: 'Catálogo',
                en: 'Catalog'
            },
            video: {
                pt: 'Vídeo',
                en: 'Video'
            },
            videos: {
                pt: 'Vídeos',
                en: 'Videos'
            },
            horario: {
                pt: 'Horários',
                en: 'Hours'
            },
            pricings: {
                pt: 'Preços',
                en: 'Pricings'
            },
            settings: {
                pt: 'Configurações',
                en: 'Settings'
            }
        },
        login: {
            title: {
                pt: 'Login Admin',
                en: 'Admin Login'
            },
            email: {
                pt: 'Email',
                en: 'Email'
            },
            password: {
                pt: 'Senha',
                en: 'Password'
            },
            button: {
                pt: 'Entrar',
                en: 'Login'
            }
        },
        dashboard: {
            overview: {
                pt: 'Visão Geral',
                en: 'Overview'
            },
            totalProducts: {
                pt: 'Total de Produtos',
                en: 'Total Products'
            },
            active: {
                pt: 'Ativos',
                en: 'Active'
            },
            inactive: {
                pt: 'Inativos',
                en: 'Inactive'
            }
        },
        products: {
            title: {
                pt: 'Produtos',
                en: 'Products'
            },
            newProduct: {
                pt: 'Novo Produto',
                en: 'New Product'
            },
            image: {
                pt: 'Imagem',
                en: 'Image'
            },
            code: {
                pt: 'Código',
                en: 'Code'
            },
            name: {
                pt: 'Nome',
                en: 'Name'
            },
            brand: {
                pt: 'Marca',
                en: 'Brand'
            },
            category: {
                pt: 'Categoria',
                en: 'Category'
            },
            status: {
                pt: 'Status',
                en: 'Status'
            },
            actions: {
                pt: 'Ações',
                en: 'Actions'
            },
            form: {
                code: {
                    pt: 'Código do Produto',
                    en: 'Product Code'
                },
                reference: {
                    pt: 'Referência',
                    en: 'Reference'
                },
                state: {
                    pt: 'Estado',
                    en: 'Status'
                },
                namePt: {
                    pt: 'Nome (Português)',
                    en: 'Name (Portuguese)'
                },
                nameEn: {
                    pt: 'Nome (Inglês)',
                    en: 'Name (English)'
                },
                descriptionPt: {
                    pt: 'Descrição (Português)',
                    en: 'Description (Portuguese)'
                },
                descriptionEn: {
                    pt: 'Descrição (Inglês)',
                    en: 'Description (English)'
                },
                unit: {
                    pt: 'Tipo de Unidade',
                    en: 'Unit Type'
                },
                unitQuantity: {
                    pt: 'Quantidade da Unidade',
                    en: 'Unit Quantity'
                },
                brand: {
                    pt: 'Marca',
                    en: 'Brand'
                },
                category: {
                    pt: 'Categoria',
                    en: 'Category'
                },
                tags: {
                    pt: 'Tags (separadas por vírgula)',
                    en: 'Tags (comma separated)'
                },
                images: {
                    pt: 'Imagens do Produto',
                    en: 'Product Images'
                },
                cancel: {
                    pt: 'Cancelar',
                    en: 'Cancel'
                },
                save: {
                    pt: 'Salvar Produto',
                    en: 'Save Product'
                },
                subtitle: {
                    pt: 'Adicione um novo produto ao seu inventário',
                    en: 'Add a new product to your inventory'
                },
                basicInfo: {
                    pt: 'Informações Básicas',
                    en: 'Basic Information'
                },
                names: {
                    pt: 'Nomes do Produto',
                    en: 'Product Names'
                },
                descriptions: {
                    pt: 'Descrições',
                    en: 'Descriptions'
                },
                details: {
                    pt: 'Detalhes do Produto',
                    en: 'Product Details'
                },
                categorization: {
                    pt: 'Categorização',
                    en: 'Categorization'
                },
                dragDrop: {
                    pt: 'Arraste e solte imagens aqui',
                    en: 'Drag & drop images here'
                },
                orClick: {
                    pt: 'ou clique para navegar',
                    en: 'or click to browse'
                },
                fileLimit: {
                    pt: 'Limite: 5MB por arquivo. Tipos permitidos: JPG, PNG, WEBP',
                    en: 'Limit: 5MB per file. Allowed types: JPG, PNG, WEBP'
                },
                categoryPlace: {
                    pt: 'ex: Eletrônicos, Roupas',
                    en: 'e.g., Electronics, Clothing'
                }
            },
            importCategories: {
                pt: 'Importar Categorias',
                en: 'Import Categories',
                instructions: {
                    pt: 'Carregue um arquivo XML contendo categorias de produtos. O sistema combinará produtos por ID e atualizará seus IDs de categoria.',
                    en: 'Upload an XML file containing product categories. The system will match products by ID and update their category IDs.'
                }
            },
            importSubcategories: {
                pt: 'Importar Subcategorias',
                en: 'Import Subcategories',
                instructions: {
                    pt: 'Carregue um arquivo XML contendo subcategorias de produtos. O sistema combinará produtos por ID e atualizará seus IDs de subcategoria.',
                    en: 'Upload an XML file containing product subcategories. The system will match products by ID and update their subcategory IDs.'
                }
            }
        },
        catalog: {
            title: {
                pt: 'Gerenciamento de Catálogo',
                en: 'Catalog Management'
            },
            subtitle: {
                pt: 'Faça upload e gerencie suas imagens e arquivos PDF do catálogo',
                en: 'Upload and manage your catalog images and PDF files'
            },
            uploadBackground: {
                pt: 'Carregar Fundo do Catálogo',
                en: 'Upload Catalog Background'
            },
            uploadImages: {
                pt: 'Fazer Upload de Imagens do Catálogo',
                en: 'Upload Catalog Images'
            },
            uploadPDF: {
                pt: 'Fazer Upload de PDF do Catálogo',
                en: 'Upload Catalog PDF'
            },
            dragDropBg: {
                pt: 'Arraste e solte a imagem de fundo aqui',
                en: 'Drag & drop background image here'
            },
            orClickBg: {
                pt: 'ou clique para selecionar imagem',
                en: 'or click to browse image'
            },
            dragDropImages: {
                pt: 'Arraste e solte imagens do catálogo aqui',
                en: 'Drag & drop catalog images here'
            },
            orClickImages: {
                pt: 'ou clique para navegar pelas imagens',
                en: 'or click to browse images'
            },
            dragDropPDF: {
                pt: 'Arraste e solte PDF do catálogo aqui',
                en: 'Drag & drop catalog PDF here'
            },
            orClickPDF: {
                pt: 'ou clique para navegar pelo PDF',
                en: 'or click to browse PDF'
            },
            uploadedFiles: {
                pt: 'Arquivos Enviados',
                en: 'Uploaded Files'
            },
            clearAll: {
                pt: 'Limpar Tudo',
                en: 'Clear All'
            },
            saveBackground: {
                pt: 'Guardar Fundo',
                en: 'Save Background'
            },
            removeBackground: {
                pt: 'Remover Fundo',
                en: 'Remove Background'
            },
            selectBackground: {
                pt: 'Por favor, selecione uma imagem de fundo.',
                en: 'Please select a background image.'
            },
            selectImages: {
                pt: 'Por favor, selecione imagens.',
                en: 'Please select images.'
            },
            selectPdf: {
                pt: 'Por favor, selecione um arquivo PDF.',
                en: 'Please select a PDF file.'
            },
            deleteConfirm: {
                pt: 'Tem certeza de que deseja excluir este arquivo?',
                en: 'Are you sure you want to delete this file?'
            },
            clearAllConfirm: {
                pt: 'Tem certeza de que deseja excluir todas as imagens do catálogo?',
                en: 'Are you sure you want to delete all catalog images?'
            },
            backgroundSaved: {
                pt: 'Fundo do catálogo salvo!',
                en: 'Catalog background saved!'
            },
            backgroundRemoved: {
                pt: 'Fundo removido.',
                en: 'Background removed.'
            },
            removeBackgroundConfirm: {
                pt: 'Tem certeza de que deseja remover o fundo?',
                en: 'Are you sure you want to remove the background?'
            },
            imagesUploaded: {
                pt: 'Imagens carregadas com sucesso!',
                en: 'Images uploaded successfully!'
            },
            pdfUploaded: {
                pt: 'PDF carregado com sucesso!',
                en: 'PDF uploaded successfully!'
            },
            enterNewOrder: {
                pt: 'Insira a nova ordem para esta imagem (atual: {{current}}):',
                en: 'Enter new order for this image (current: {{current}}):'
            },
            invalidOrder: {
                pt: 'Por favor, insira um número de ordem válido (1 ou maior).',
                en: 'Please enter a valid order number (1 or greater).'
            },
            catalogVideo: {
                pt: 'Vídeo do Catálogo',
                en: 'Catalog Video'
            }
        },
        videos: {
            title: {
                pt: 'Gerenciamento de Vídeos',
                en: 'Video Management'
            },
            subtitle: {
                pt: 'Configure o link do vídeo do Facebook para a seção de catálogo',
                en: 'Configure the Facebook video link for the catalog section'
            },
            facebookVideoLink: {
                pt: 'Link do Vídeo do Facebook',
                en: 'Facebook Video Link'
            },
            facebookVideoLinkPlaceholder: {
                pt: 'https://www.facebook.com/...',
                en: 'https://www.facebook.com/...'
            },
            facebookVideoLinkHint: {
                pt: 'Cole o link completo do vídeo do Facebook. Este vídeo será exibido quando os usuários clicarem no botão de reprodução na seção de catálogo.',
                en: 'Paste the full Facebook video link. This video will be displayed when users click the play button in the catalog section.'
            },
            currentLink: {
                pt: 'Link Atual:',
                en: 'Current Link:'
            },
            saveLink: {
                pt: 'Salvar Link',
                en: 'Save Link'
            },
            saving: {
                pt: 'Salvando...',
                en: 'Saving...'
            },
            removeLink: {
                pt: 'Remover Link',
                en: 'Remove Link'
            },
            linkSaved: {
                pt: 'Link de vídeo do catálogo salvo com sucesso!',
                en: 'Catalog video link saved successfully!'
            },
            linkRemoved: {
                pt: 'Link de vídeo removido.',
                en: 'Video link removed.'
            },
            enterVideoLink: {
                pt: 'Por favor, insira um link de vídeo do Facebook.',
                en: 'Please enter a Facebook video link.'
            },
            enterValidLink: {
                pt: 'Por favor, insira um link válido do Facebook.',
                en: 'Please enter a valid Facebook link.'
            },
            removeLinkConfirm: {
                pt: 'Tem certeza de que deseja remover o link de vídeo do catálogo?',
                en: 'Are you sure you want to remove the catalog video link?'
            },
            howToGetLink: {
                pt: 'Como obter o link do vídeo do Facebook:',
                en: 'How to get Facebook video link:'
            },
            howToGetLinkStep1: {
                pt: 'Vá para o vídeo no Facebook',
                en: 'Go to the video on Facebook'
            },
            howToGetLinkStep2: {
                pt: 'Clique nos três pontos (...) no canto superior direito do vídeo',
                en: 'Click the three dots (...) in the top right corner of the video'
            },
            howToGetLinkStep3: {
                pt: 'Selecione "Copiar link"',
                en: 'Select "Copy link"'
            },
            howToGetLinkStep4: {
                pt: 'Cole o link aqui',
                en: 'Paste the link here'
            }
        },
        horario: {
            title: {
                pt: 'Gerenciamento de Horários',
                en: 'Hours Management'
            },
            subtitle: {
                pt: 'Configure os horários da barra superior e da seção de horários',
                en: 'Configure the top bar and hours section schedules'
            },
            topBarSchedule: {
                pt: 'Horário da Barra Superior',
                en: 'Top Bar Schedule'
            },
            topBarSchedulePt: {
                pt: 'Português (PT)',
                en: 'Portuguese (PT)'
            },
            topBarScheduleEn: {
                pt: 'Inglês (EN)',
                en: 'English (EN)'
            },
            storeHours: {
                pt: 'Horário da Loja',
                en: 'Store Hours'
            },
            workshopHours: {
                pt: 'Horário da Oficina',
                en: 'Workshop Hours'
            },
            weekdays: {
                pt: 'Seg-Sáb',
                en: 'Mon-Sat'
            },
            sunday: {
                pt: 'Domingo',
                en: 'Sunday'
            },
            holidays: {
                pt: 'Feriados',
                en: 'Holidays'
            },
            save: {
                pt: 'Salvar Horários',
                en: 'Save Hours'
            },
            saving: {
                pt: 'Salvando...',
                en: 'Saving...'
            },
            saved: {
                pt: 'Horários salvos com sucesso!',
                en: 'Hours saved successfully!'
            },
            error: {
                pt: 'Erro ao salvar horários:',
                en: 'Error saving hours:'
            }
        },
        pricings: {
            title: {
                pt: 'Gerenciamento de Preços',
                en: 'Pricing Management'
            },
            subtitle: {
                pt: 'Configure os valores da seção de preços transparentes',
                en: 'Configure the transparent pricing section amounts'
            },
            preview: {
                pt: 'Pré-visualização',
                en: 'Preview'
            },
            editAmount: {
                pt: 'Editar Valores',
                en: 'Edit Amounts'
            },
            customReview: {
                pt: 'Revisão Personalizada',
                en: 'Custom Review'
            },
            oilReview: {
                pt: 'Revisão com Óleo',
                en: 'Oil Review'
            },
            oilFilterReview: {
                pt: 'Revisão com Óleo + Filtro',
                en: 'Oil + Filter Review'
            },
            amount: {
                pt: 'Valor',
                en: 'Amount'
            },
            save: {
                pt: 'Salvar Preços',
                en: 'Save Prices'
            },
            saving: {
                pt: 'Salvando...',
                en: 'Saving...'
            },
            saved: {
                pt: 'Preços salvos com sucesso!',
                en: 'Prices saved successfully!'
            },
            error: {
                pt: 'Erro ao salvar preços',
                en: 'Error saving prices'
            }
        },
        video: {
            title: {
                pt: 'Gerenciamento de Vídeo',
                en: 'Video Management'
            },
            subtitle: {
                pt: 'Carregue e gerencie vídeos para o site',
                en: 'Upload and manage videos for the website'
            },
            uploadVideo: {
                pt: 'Carregar Vídeo',
                en: 'Upload Video'
            },
            videoType: {
                pt: 'Tipo de Vídeo',
                en: 'Video Type'
            },
            videoTypeHint: {
                pt: 'Selecione onde este vídeo será exibido',
                en: 'Select where this video will be displayed'
            },
            dragDrop: {
                pt: 'Arraste e solte o arquivo de vídeo aqui',
                en: 'Drag & drop video file here'
            },
            orClick: {
                pt: 'ou clique para navegar pelo arquivo de vídeo',
                en: 'or click to browse video file'
            },
            upload: {
                pt: 'Carregar Vídeo',
                en: 'Upload Video'
            },
            uploadedVideos: {
                pt: 'Vídeos Carregados',
                en: 'Uploaded Videos'
            },
            delete: {
                pt: 'Excluir',
                en: 'Delete'
            },
            aboutVideo: {
                pt: 'Vídeo Sobre Nós',
                en: 'About Us Video'
            },
            sectionVideo: {
                pt: 'Vídeo da Seção',
                en: 'Section Video'
            },
            catalogVideo: {
                pt: 'Vídeo do Catálogo',
                en: 'Catalog Video'
            },
            selectVideo: {
                pt: 'Por favor, selecione um arquivo de vídeo.',
                en: 'Please select a video file.'
            },
            selectType: {
                pt: 'Por favor, selecione um tipo de vídeo.',
                en: 'Please select a video type.'
            },
            invalidFile: {
                pt: 'Por favor, selecione um arquivo de vídeo válido.',
                en: 'Please select a valid video file.'
            },
            uploadSuccess: {
                pt: 'Vídeo carregado com sucesso!',
                en: 'Video uploaded successfully!'
            },
            deleteConfirm: {
                pt: 'Tem certeza de que deseja excluir este vídeo?',
                en: 'Are you sure you want to delete this video?'
            },
            deleteSuccess: {
                pt: 'Vídeo excluído com sucesso!',
                en: 'Video deleted successfully!'
            }
        }
    },

    SERVICE_DETAILS: {
        alignment: {
            pageTitle: {
                pt: 'Alinhamento de direção em Oliveira de Azeméis',
                en: 'Wheel alignment in Oliveira de Azeméis'
            },
            title: {
                pt: 'Alinhamento de Direção – Precisão e estabilidade para todas as viaturas',
                en: 'Steering Alignment – Precision and stability for all vehicles'
            },
            intro: {
                pt: 'O alinhamento de direção é essencial para garantir segurança, conforto e durabilidade dos pneus. No Roady Centro-Auto Oliveira de Azeméis, realizamos alinhamentos com tecnologia de precisão, adequados a veículos novos e usados de todas as marcas.',
                en: 'Steering alignment is essential to ensure safety, comfort and tire durability. At Roady Centro-Auto Oliveira de Azeméis, we perform alignments with precision technology, suitable for new and used vehicles of all brands.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'O desalinhamento provoca desgaste irregular dos pneus, aumento do consumo e perda de estabilidade. Pequenos impactos, buracos ou substituições de pneus podem alterar o eixo de direção, tornando necessária a correção do ângulo das rodas.',
                en: 'Misalignment causes irregular tire wear, increased consumption and loss of stability. Small impacts, potholes or tire replacements can alter the steering axis, making it necessary to correct the wheel angle.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Os técnicos utilizam equipamento de medição computadorizado que analisa a geometria das rodas e corrige todos os parâmetros de direção conforme as especificações do fabricante. O resultado é uma condução mais suave e segura.',
                en: 'Technicians use computerized measurement equipment that analyzes wheel geometry and corrects all steering parameters according to manufacturer specifications. The result is smoother and safer driving.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Alinhamento de direção computadorizado de alta precisão.',
                    'Serviço adaptado a todas as marcas e modelos.',
                    'Redução de desgaste e melhoria da estabilidade.',
                    'Condução mais segura e confortável.'
                ],
                en: [
                    'High precision computerized steering alignment.',
                    'Service adapted to all brands and models.',
                    'Reduced wear and improved stability.',
                    'Safer and more comfortable driving.'
                ]
            },
            cta: {
                pt: 'Marque o alinhamento de direção no Roady Centro-Auto Oliveira de Azeméis e conduza com total equilíbrio e segurança.',
                en: 'Book steering alignment at Roady Centro-Auto Oliveira de Azeméis and drive with complete balance and safety.'
            }
        },
        diagnosticTest: {
            pageTitle: {
                pt: 'Diagnóstico eletrónico automóvel em Oliveira de Azeméis',
                en: 'Car electronic diagnostics in Oliveira de Azeméis'
            },
            title: {
                pt: 'Teste Diagnóstico Automóvel – Precisão para todas as viaturas',
                en: 'Automotive Diagnostic Test – Precision for all vehicles'
            },
            intro: {
                pt: 'O Teste Diagnóstico é o ponto de partida essencial para identificar falhas e garantir o bom funcionamento de qualquer veículo, novo ou usado. No Roady Centro-Auto Oliveira de Azeméis, realizamos diagnósticos completos com equipamentos de leitura eletrónica e análise técnica adaptada a todas as marcas e modelos.',
                en: 'Diagnostic Test is the essential starting point to identify failures and ensure the proper functioning of any vehicle, new or used. At Roady Centro-Auto Oliveira de Azeméis, we perform complete diagnostics with electronic reading equipment and technical analysis adapted to all brands and models.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'Mesmo sem luzes de aviso acesas, pequenas falhas podem comprometer o desempenho e aumentar o consumo. O diagnóstico permite detetar avarias mecânicas e eletrónicas em tempo útil, prevenindo problemas maiores e garantindo segurança e fiabilidade na estrada.',
                en: 'Even without warning lights on, small failures can compromise performance and increase consumption. Diagnosis allows detecting mechanical and electronic failures in time, preventing bigger problems and ensuring safety and reliability on the road.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'A equipa Roady utiliza ferramentas de diagnóstico certificadas, compatíveis com veículos de qualquer ano. O sistema recolhe e interpreta códigos de erro, permitindo uma avaliação rigorosa antes de qualquer intervenção mecânica.',
                en: 'The Roady team uses certified diagnostic tools, compatible with vehicles of any year. The system collects and interprets error codes, allowing a rigorous assessment before any mechanical intervention.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Diagnóstico eletrónico e técnico completo.',
                    'Compatível com veículos de todas as idades e marcas.',
                    'Técnicos especializados em interpretação de avarias.',
                    'Rapidez, transparência e precisão no resultado.'
                ],
                en: [
                    'Complete electronic and technical diagnosis.',
                    'Compatible with vehicles of all ages and brands.',
                    'Technicians specialized in failure interpretation.',
                    'Speed, transparency and precision in results.'
                ]
            },
            cta: {
                pt: 'Faça o seu teste diagnóstico no Roady Centro-Auto Oliveira de Azeméis e conduza com total confiança.',
                en: 'Have your diagnostic test done at Roady Centro-Auto Oliveira de Azeméis and drive with complete confidence.'
            }
        },
        roadyReview: {
            pageTitle: {
                pt: 'Revisão automóvel em Oliveira de Azeméis',
                en: 'Car servicing in Oliveira de Azeméis'
            },
            title: {
                pt: 'Revisões Roady – Manutenção preventiva adaptada ao seu veículo',
                en: 'Roady Reviews – Preventive maintenance adapted to your vehicle'
            },
            intro: {
                pt: 'As Revisões Roady garantem o bom funcionamento do seu automóvel ao longo do tempo. Adaptamos os planos de revisão às necessidades reais do veículo e ao seu historial de utilização.',
                en: 'Roady Reviews ensure your car runs smoothly over time. We adapt review plans to the vehicle\'s actual needs and usage history.'
            },
            importanceTitle: {
                pt: 'Quando fazer a revisão',
                en: 'When to service your car'
            },
            importance: {
                pt: 'A manutenção regular previne avarias inesperadas e prolonga a vida útil do motor. Revisões periódicas reduzem custos a longo prazo e aumentam a segurança na estrada.',
                en: 'Regular maintenance prevents unexpected breakdowns and extends engine life. Periodic reviews reduce long-term costs and increase road safety.'
            },
            howTitle: {
                pt: 'O que fica feito numa revisão',
                en: 'What gets done in a service'
            },
            how: {
                pt: 'Cada revisão inclui a verificação de óleo, filtros, travões, suspensão, sistema elétrico e muito mais. Seguimos as especificações do fabricante e alertamos para qualquer componente que exija atenção futura.',
                en: 'Each review includes checking oil, filters, brakes, suspension, electrical system and much more. We follow manufacturer specifications and alert you to any component that requires future attention.'
            },
            warrantyTitle: {
                pt: 'A garantia do seu carro mantém-se',
                en: 'Your car\'s warranty is kept'
            },
            warrantyText: {
                pt: 'É a dúvida mais frequente: fazer a revisão fora da marca faz perder a garantia? Não faz. Desde que a revisão cumpra o plano de manutenção do fabricante, use peças de qualidade equivalente e fique devidamente registada, a garantia contratual do automóvel mantém-se.',
                en: 'It is the most frequent question: does servicing outside the brand network void the warranty? It does not. As long as the service follows the manufacturer\'s maintenance plan, uses parts of equivalent quality and is duly recorded, the car\'s contractual warranty is kept.'
            },
            costTitle: {
                pt: 'Quanto custa uma revisão',
                en: 'How much a service costs'
            },
            costText1: {
                pt: 'É a primeira pergunta de quem procura, e a resposta honesta é que depende. Depende do modelo, da quilometragem e do que o plano do fabricante determina nesta etapa — a revisão dos 60 mil quilómetros não é a mesma dos 120 mil.',
                en: 'It is the first question people ask, and the honest answer is that it depends. It depends on the model, the mileage and what the manufacturer\'s plan sets for this stage — the 60,000 km service is not the same as the 120,000 km one.'
            },
            costText2: {
                pt: 'O que garantimos é o método: confirmamos o que o seu carro precisa, apresentamos o valor antes de começar e não avançamos com nada que não tenha aprovado. Indique-nos a matrícula e a quilometragem e damos-lhe um número.',
                en: 'What we guarantee is the method: we confirm what your car needs, present the price before starting and never proceed with anything you have not approved. Give us the licence plate and mileage and we will give you a number.'
            },
            oilChangeTitle: {
                pt: 'Mudança de óleo e filtro',
                en: 'Oil and filter change'
            },
            oilChangeText: {
                pt: 'Também fazemos a mudança de óleo e filtro como serviço isolado, com o óleo da especificação indicada para o seu motor. Em alguns packs o filtro já está incluído — em loja explicamos as opções. Peça orçamento indicando a matrícula.',
                en: 'We also do the oil and filter change as a standalone service, with the oil specification indicated for your engine. In some packs the filter is already included — in store we explain the options. Request a quote indicating the licence plate.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Revisões completas e personalizadas.',
                    'Técnicos certificados e experientes.',
                    'Peças de qualidade e garantia incluída.',
                    'Relatório detalhado após cada revisão.'
                ],
                en: [
                    'Complete and personalized reviews.',
                    'Certified and experienced technicians.',
                    'Quality parts and warranty included.',
                    'Detailed report after each review.'
                ]
            },
            cta: {
                pt: 'Marque a sua Revisão Roady no Centro-Auto Oliveira de Azeméis e mantenha o seu veículo em perfeito estado.',
                en: 'Book your Roady Review at Centro-Auto Oliveira de Azeméis and keep your vehicle in perfect condition.'
            }
        },
        shockAbsorbers: {
            pageTitle: {
                pt: 'Amortecedores e suspensão em Oliveira de Azeméis',
                en: 'Shock absorbers and suspension in Oliveira de Azeméis'
            },
            title: {
                pt: 'Amortecedores – Conforto e segurança em qualquer estrada',
                en: 'Shock Absorbers – Comfort and safety on any road'
            },
            intro: {
                pt: 'Os amortecedores garantem estabilidade e conforto de condução. No Roady Oliveira de Azeméis, realizamos diagnósticos precisos e substituições com peças de qualidade para todas as marcas.',
                en: 'Shock absorbers ensure stability and driving comfort. At Roady Oliveira de Azeméis, we perform accurate diagnostics and replacements with quality parts for all brands.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'Amortecedores desgastados comprometem a aderência dos pneus à estrada, aumentam a distância de travagem e causam vibrações excessivas. A substituição a tempo melhora o controlo do veículo e a segurança dos ocupantes.',
                en: 'Worn shock absorbers compromise tire grip on the road, increase braking distance and cause excessive vibrations. Timely replacement improves vehicle control and occupant safety.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Avaliamos o estado dos amortecedores através de testes visuais e de performance. Substituímos por componentes adequados ao tipo de veículo e condições de utilização, incluindo alinhamento posterior.',
                en: 'We assess the condition of shock absorbers through visual and performance tests. We replace with components suitable for the type of vehicle and usage conditions, including subsequent alignment.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Diagnóstico completo da suspensão.',
                    'Peças de marcas reconhecidas.',
                    'Serviço rápido e eficaz.',
                    'Conforto e segurança garantidos.'
                ],
                en: [
                    'Complete suspension diagnosis.',
                    'Parts from recognized brands.',
                    'Fast and effective service.',
                    'Comfort and safety guaranteed.'
                ]
            },
            cta: {
                pt: 'Verifique os amortecedores no Roady Centro-Auto Oliveira de Azeméis e conduza com total estabilidade.',
                en: 'Check shock absorbers at Roady Centro-Auto Oliveira de Azeméis and drive with complete stability.'
            }
        },
        inspection: {
            pageTitle: {
                pt: 'Preparação para a inspeção em Oliveira de Azeméis',
                en: 'Inspection preparation in Oliveira de Azeméis'
            },
            title: {
                pt: 'Inspeção Periódica Obrigatória (IPO) – Conformidade e segurança garantidas',
                en: 'Mandatory Periodic Inspection (IPO) – Compliance and safety guaranteed'
            },
            intro: {
                pt: 'A Inspeção Periódica Obrigatória é essencial para circular em segurança e legalidade. No Roady Oliveira de Azeméis, preparamos o seu veículo para a inspeção e apoiamos em todo o processo.',
                en: 'Mandatory Periodic Inspection is essential for safe and legal circulation. At Roady Oliveira de Azeméis, we prepare your vehicle for inspection and support you throughout the process.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'A inspeção avalia o estado técnico do veículo e identifica componentes em não conformidade. Uma preparação prévia aumenta as hipóteses de aprovação imediata e evita custos com reinspeções.',
                en: 'Inspection assesses the vehicle\'s technical condition and identifies non-compliant components. Prior preparation increases chances of immediate approval and avoids reinspection costs.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Realizamos uma pré-inspeção completa: travões, luzes, pneus, suspensão e emissões. Corrigimos eventuais falhas antes da inspeção oficial. Peça orçamento sem compromisso.',
                en: 'We perform a complete pre-inspection: brakes, lights, tires, suspension and emissions. We correct any failures before official inspection. Request a no-obligation quote.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Pré-inspeção técnica detalhada.',
                    'Correção de falhas detetadas.',
                    'Acompanhamento no processo oficial.',
                    'Maior probabilidade de aprovação imediata.'
                ],
                en: [
                    'Detailed technical pre-inspection.',
                    'Correction of detected failures.',
                    'Follow-up in the official process.',
                    'Higher probability of immediate approval.'
                ]
            },
            cta: {
                pt: 'Prepare a inspeção do seu veículo no Roady Centro-Auto Oliveira de Azeméis e circule em total tranquilidade.',
                en: 'Prepare your vehicle inspection at Roady Centro-Auto Oliveira de Azeméis and drive with complete peace of mind.'
            }
        },
        generalMechanics: {
            pageTitle: {
                pt: 'Mecânica automóvel em Oliveira de Azeméis',
                en: 'Car mechanics in Oliveira de Azeméis'
            },
            title: {
                pt: 'Mecânica Geral – Soluções completas para qualquer avaria',
                en: 'General Mechanics – Complete solutions for any breakdown'
            },
            intro: {
                pt: 'A Mecânica Geral abrange todas as intervenções técnicas do seu automóvel. No Roady Oliveira de Azeméis, reparamos motores, transmissões, sistemas elétricos e muito mais, com precisão e qualidade.',
                en: 'General Mechanics covers all technical interventions on your car. At Roady Oliveira de Azeméis, we repair engines, transmissions, electrical systems and much more, with precision and quality.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'A manutenção corretiva é essencial quando surgem avarias inesperadas. Uma intervenção técnica competente garante a resolução eficaz e duradoura dos problemas mecânicos.',
                en: 'Corrective maintenance is essential when unexpected breakdowns occur. Competent technical intervention ensures effective and lasting resolution of mechanical problems.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Diagnosticamos a origem da avaria, apresentamos orçamento transparente e procedemos à reparação com peças certificadas. Cada intervenção é registada e inclui garantia de serviço.',
                en: 'We diagnose the source of the breakdown, present a transparent quote and proceed with repair using certified parts. Each intervention is recorded and includes service warranty.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Equipa técnica especializada.',
                    'Orçamentos transparentes e sem surpresas.',
                    'Peças de qualidade com garantia.',
                    'Soluções adaptadas a qualquer marca.'
                ],
                en: [
                    'Specialized technical team.',
                    'Transparent quotes with no surprises.',
                    'Quality parts with warranty.',
                    'Solutions adapted to any brand.'
                ]
            },
            cta: {
                pt: 'Confie a mecânica do seu automóvel ao Roady Centro-Auto Oliveira de Azeméis e volte à estrada com segurança.',
                en: 'Trust your car mechanics to Roady Centro-Auto Oliveira de Azeméis and get back on the road safely.'
            }
        },
        workshopServices: {
            pageTitle: {
                pt: 'Pacote de Serviços de Oficina',
                en: 'Workshop Services Pack'
            },
            title: {
                pt: 'Pack de Serviços de Oficina – Manutenção completa numa só visita',
                en: 'Workshop Services Pack – Complete maintenance in one visit'
            },
            intro: {
                pt: 'O Pack de Serviços Roady permite tratar de várias necessidades do seu automóvel de uma só vez, poupando tempo e garantindo cuidado integral. Personalizamos o pack conforme as suas necessidades.',
                en: 'The Roady Services Pack allows you to take care of several needs of your car at once, saving time and ensuring comprehensive care. We customize the pack according to your needs.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'Realizar várias manutenções em simultâneo otimiza tempo e custos. A manutenção integrada garante que todos os sistemas estejam em perfeito estado de funcionamento.',
                en: 'Performing several maintenances simultaneously optimizes time and costs. Integrated maintenance ensures that all systems are in perfect working order.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Combinamos revisão completa, mudança de óleo, verificação de travões, diagnóstico eletrónico e outros serviços numa só visita. O cliente define o que pretende incluir.',
                en: 'We combine complete review, oil change, brake check, electronic diagnosis and other services in one visit. The customer defines what they want to include.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Pacotes personalizáveis conforme necessidade.',
                    'Economia de tempo e deslocações.',
                    'Orçamento global mais vantajoso.',
                    'Relatório completo após intervenção.'
                ],
                en: [
                    'Customizable packages according to need.',
                    'Time and travel savings.',
                    'More advantageous global budget.',
                    'Complete report after intervention.'
                ]
            },
            cta: {
                pt: 'Peça orçamento sem compromisso.',
                en: 'Request a no-obligation quote.'
            }
        },
        airConditioning: {
            pageTitle: {
                pt: 'Ar condicionado auto em Oliveira de Azeméis: carregamento e manutenção',
                en: 'Car air conditioning in Oliveira de Azeméis: recharge and maintenance'
            },
            title: {
                pt: 'Ar Condicionado – Conforto e ar puro em qualquer estação',
                en: 'Air Conditioning – Comfort and pure air in any season'
            },
            intro: {
                pt: 'Um sistema de ar condicionado eficiente melhora o conforto e a qualidade do ar dentro do veículo. No Roady Oliveira de Azeméis, realizamos carregamentos, higienizações e reparações completas de sistemas de climatização.',
                en: 'An efficient air conditioning system improves comfort and air quality inside the vehicle. At Roady Oliveira de Azeméis, we perform charging, cleaning and complete repairs of climate control systems.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'Com o tempo, o gás refrigerante diminui e os filtros acumulam impurezas, reduzindo a eficiência e a qualidade do ar. Um sistema em mau estado aumenta o consumo de combustível e pode causar odores desagradáveis.',
                en: 'Over time, the refrigerant gas decreases and filters accumulate impurities, reducing efficiency and air quality. A poorly maintained system increases fuel consumption and can cause unpleasant odors.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Fazemos a verificação de pressão e temperatura, limpeza dos circuitos, substituição do filtro de habitáculo e carregamento do gás refrigerante. O serviço é adaptado a todos os tipos de veículos, com ou sem climatizador automático.',
                en: 'We check pressure and temperature, clean circuits, replace the cabin filter and recharge the refrigerant gas. The service is adapted to all types of vehicles, with or without automatic climate control.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Equipamentos de diagnóstico e carregamento certificados.',
                    'Higienização completa e filtros de alta eficiência.',
                    'Serviço compatível com todos os tipos de gás.',
                    'Conforto térmico e qualidade do ar garantidos.'
                ],
                en: [
                    'Certified diagnostic and charging equipment.',
                    'Complete cleaning and high efficiency filters.',
                    'Service compatible with all types of gas.',
                    'Thermal comfort and air quality guaranteed.'
                ]
            },
            cta: {
                pt: 'Respire conforto — marque a revisão do ar condicionado no Roady Centro-Auto Oliveira de Azeméis.',
                en: 'Breathe comfort — book air conditioning maintenance at Roady Centro-Auto Oliveira de Azeméis.'
            }
        },
        washing: {
            pageTitle: {
                pt: 'Lavagem auto em Oliveira de Azeméis: interior e exterior',
                en: 'Car wash in Oliveira de Azeméis: interior and exterior'
            },
            title: {
                pt: 'Lavagem Automóvel – Brilho e proteção exterior',
                en: 'Car Wash – Shine and exterior protection'
            },
            intro: {
                pt: 'A lavagem regular do automóvel protege a pintura e mantém o aspeto impecável. No Roady Oliveira de Azeméis, oferecemos serviços de lavagem exterior e interior com produtos de qualidade.',
                en: 'Regular car washing protects the paint and maintains impeccable appearance. At Roady Oliveira de Azeméis, we offer exterior and interior washing services with quality products.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'A sujidade acumulada acelera a oxidação da pintura e prejudica a visibilidade. A lavagem frequente preserva o valor do automóvel e aumenta a durabilidade dos materiais exteriores.',
                en: 'Accumulated dirt accelerates paint oxidation and impairs visibility. Frequent washing preserves the car\'s value and increases the durability of exterior materials.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Realizamos lavagem exterior com produtos biodegradáveis, aspiração interior, limpeza de estofos e vidros. Incluímos tratamentos de proteção de pintura e polimento quando solicitado.',
                en: 'We perform exterior washing with biodegradable products, interior vacuuming, upholstery and glass cleaning. We include paint protection and polishing treatments when requested.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Produtos de limpeza profissionais.',
                    'Lavagem manual e automática disponíveis.',
                    'Serviço rápido e eficiente.',
                    'Cuidado especial com acabamentos delicados.'
                ],
                en: [
                    'Professional cleaning products.',
                    'Manual and automatic washing available.',
                    'Fast and efficient service.',
                    'Special care with delicate finishes.'
                ]
            },
            cta: {
                pt: 'Mantenha o seu automóvel impecável — peça orçamento sem compromisso.',
                en: 'Keep your car shiny — request a no-obligation quote.'
            }
        },
        headlightRestoration: {
            pageTitle: {
                pt: 'Restauro de faróis em Oliveira de Azeméis',
                en: 'Headlight restoration in Oliveira de Azeméis'
            },
            title: {
                pt: 'Restauro de Faróis – Visibilidade e segurança noturna',
                en: 'Headlight Restoration – Visibility and night safety'
            },
            intro: {
                pt: 'Faróis opacos comprometem a iluminação da estrada. No Roady Oliveira de Azeméis, restauramos faróis com técnicas avançadas, devolvendo transparência e eficiência luminosa.',
                en: 'Opaque headlights compromise road lighting. At Roady Oliveira de Azeméis, we restore headlights with advanced techniques, restoring transparency and light efficiency.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'Com o tempo, os faróis ficam baços devido à exposição solar e intempéries. O restauro melhora a visibilidade noturna, aumenta a segurança e evita a substituição completa dos faróis.',
                en: 'Over time, headlights become dull due to sun exposure and weather. Restoration improves night visibility, increases safety and avoids complete headlight replacement.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Utilizamos técnicas de polimento e aplicação de camadas protetoras UV. O processo remove a camada oxidada e revitaliza o material, garantindo durabilidade e eficiência luminosa.',
                en: 'We use polishing techniques and application of UV protective layers. The process removes the oxidized layer and revitalizes the material, ensuring durability and light efficiency.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Restauro profissional e duradouro.',
                    'Melhoria imediata da iluminação.',
                    'Custos reduzidos face à substituição.',
                    'Proteção contra oxidação futura.'
                ],
                en: [
                    'Professional and lasting restoration.',
                    'Immediate lighting improvement.',
                    'Reduced costs compared to replacement.',
                    'Protection against future oxidation.'
                ]
            },
            cta: {
                pt: 'Restaure os faróis do seu automóvel no Roady Centro-Auto Oliveira de Azeméis e veja melhor à noite.',
                en: 'Restore your car headlights at Roady Centro-Auto Oliveira de Azeméis and see better at night.'
            }
        },
        batteries: {
            pageTitle: {
                pt: 'Baterias automóvel em Oliveira de Azeméis: teste e substituição',
                en: 'Car batteries in Oliveira de Azeméis: testing and replacement'
            },
            title: {
                pt: 'Baterias Automóvel – Energia fiável em qualquer momento',
                en: 'Automotive Batteries – Reliable energy at any time'
            },
            intro: {
                pt: 'A bateria é o coração do sistema elétrico do seu automóvel. No Roady Oliveira de Azeméis, avaliamos, substituímos e testamos baterias para todas as viaturas, assegurando arranque imediato e funcionamento correto de todos os sistemas eletrónicos.',
                en: 'The battery is the heart of your vehicle\'s electrical system. At Roady Oliveira de Azeméis, we assess, replace and test batteries for all vehicles, ensuring immediate starting and correct operation of all electronic systems.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'O desgaste natural, as variações de temperatura e a falta de utilização podem comprometer o desempenho da bateria. Uma bateria fraca é uma das principais causas de imobilização do veículo. A verificação regular evita surpresas desagradáveis.',
                en: 'Natural wear, temperature variations and lack of use can compromise battery performance. A weak battery is one of the main causes of vehicle immobilization. Regular checking prevents unpleasant surprises.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Os técnicos realizam um teste de carga e verificação de voltagem. Se for necessária substituição, instalamos baterias adequadas ao tipo de motor e tecnologia do veículo, com calibração e registo no sistema eletrónico quando aplicável.',
                en: 'Technicians perform a charge test and voltage check. If replacement is necessary, we install batteries suitable for the type of engine and vehicle technology, with calibration and registration in the electronic system when applicable.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Teste gratuito e diagnóstico preciso.',
                    'Baterias de qualidade para todas as marcas.',
                    'Instalação imediata e segura.',
                    'Garantia de desempenho e durabilidade.'
                ],
                en: [
                    'Free test and precise diagnosis.',
                    'Quality batteries for all brands.',
                    'Immediate and safe installation.',
                    'Performance and durability guarantee.'
                ]
            },
            cta: {
                pt: 'Evite imprevistos — verifique a bateria do seu automóvel no Roady Centro-Auto Oliveira de Azeméis.',
                en: 'Avoid unexpected situations — check your vehicle\'s battery at Roady Centro-Auto Oliveira de Azeméis.'
            }
        },
        brakes: {
            pageTitle: {
                pt: 'Travões em Oliveira de Azeméis: verificação, medição e substituição',
                en: 'Brakes in Oliveira de Azeméis: check, measurement and replacement'
            },
            title: {
                pt: 'Travões – Segurança e confiança em qualquer estrada',
                en: 'Brakes – Safety and confidence on any road'
            },
            intro: {
                pt: 'O sistema de travagem é vital em todos os veículos, seja um modelo recente ou um automóvel com anos de estrada. No Roady Oliveira de Azeméis, avaliamos e substituímos travões com precisão e materiais de elevada qualidade.',
                en: 'The braking system is vital in all vehicles, whether a recent model or a car with years on the road. At Roady Oliveira de Azeméis, we assess and replace brakes with precision and high-quality materials.'
            },
            importanceTitle: {
                pt: 'Importância do serviço',
                en: 'Importance of the service'
            },
            importance: {
                pt: 'Travões em mau estado comprometem a segurança e aumentam a distância de travagem. A verificação regular permite prevenir falhas e garantir resposta imediata em situações de emergência.',
                en: 'Brakes in poor condition compromise safety and increase braking distance. Regular checking allows preventing failures and ensuring immediate response in emergency situations.'
            },
            howTitle: {
                pt: 'Como é feito no Roady',
                en: 'How it\'s done at Roady'
            },
            how: {
                pt: 'Os técnicos verificam o desgaste de pastilhas, discos e fluido de travões. Sempre que necessário, substituem componentes com peças homologadas, assegurando o equilíbrio e a potência de travagem adequados.',
                en: 'Technicians check the wear of pads, discs and brake fluid. When necessary, they replace components with approved parts, ensuring proper balance and braking power.'
            },
            advantagesTitle: {
                pt: 'Vantagens Roady Oliveira de Azeméis:',
                en: 'Roady Oliveira de Azeméis Advantages:'
            },
            advantages: {
                pt: [
                    'Serviço completo para qualquer marca e modelo.',
                    'Equipamentos de teste e medição de precisão.',
                    'Peças certificadas e duradouras.',
                    'Teste final de eficiência incluído.'
                ],
                en: [
                    'Complete service for any brand and model.',
                    'Precision testing and measurement equipment.',
                    'Certified and durable parts.',
                    'Final efficiency test included.'
                ]
            },
            cta: {
                pt: 'Peça orçamento sem compromisso e conduza com total segurança.',
                en: 'Request a no-obligation quote and drive with complete safety.'
            }
        }
    },

    COOKIES_POLICY: {
        title: {
            pt: 'Política de Cookies',
            en: 'Cookie Policy'
        },
        subtitle: {
            pt: 'Roady Centro-Auto Oliveira de Azeméis',
            en: 'Roady Centro-Auto Oliveira de Azeméis'
        },
        section1: {
            pt: '1. O que são cookies',
            en: '1. What are cookies'
        },
        section1Text: {
            pt: 'Cookies são pequenos ficheiros de texto armazenados no dispositivo do utilizador quando visita um website. Permitem melhorar a experiência de navegação, guardar preferências e realizar medições estatísticas e de segurança.',
            en: 'Cookies are small text files stored on the user\'s device when visiting a website. They allow improving the browsing experience, saving preferences and performing statistical and security measurements.'
        },
        section2: {
            pt: '2. Tipos de cookies utilizados',
            en: '2. Types of cookies used'
        },
        section2Item1: {
            pt: 'Estritamente necessários – essenciais ao funcionamento do site;',
            en: 'Strictly necessary – essential for the site\'s operation;'
        },
        section2Item2: {
            pt: 'Analíticos/de desempenho – avaliam o uso do site e permitem melhorias (ex.: Google Analytics com anonimização de IP);',
            en: 'Analytical/performance – assess site usage and allow improvements (e.g.: Google Analytics with IP anonymization);'
        },
        section2Item3: {
            pt: 'Funcionalidade – guardam preferências como idioma;',
            en: 'Functionality – store preferences such as language;'
        },
        section2Item4: {
            pt: 'De terceiros – serviços externos (mapas, vídeos, redes sociais).',
            en: 'Third-party – external services (maps, videos, social networks).'
        },
        section3: {
            pt: '3. Consentimento',
            en: '3. Consent'
        },
        section3Text: {
            pt: 'Na primeira visita, o site apresenta um banner de consentimento que permite:',
            en: 'On the first visit, the site presents a consent banner that allows:'
        },
        section3Item1: {
            pt: 'Aceitar todos os cookies – matters;',
            en: 'Accept all cookies – matters;'
        },
        section3Item2: {
            pt: 'Recusar cookies não necessários – matters;',
            en: 'Refuse non-essential cookies – matters;'
        },
        section3Item3: {
            pt: 'Definir preferências – matters;',
            en: 'Set preferences – matters;'
        },
        section3Item4: {
            pt: 'Aceder à presente política – matters.',
            en: 'Access this policy – matters.'
        },
        section3Text2: {
            pt: 'O consentimento pode ser retirado a qualquer momento.',
            en: 'Consent can be withdrawn at any time.'
        },
        section4: {
            pt: '4. Gestão de cookies',
            en: '4. Cookie management'
        },
        section4Text1: {
            pt: 'O utilizador pode configurar o navegador para bloquear ou eliminar cookies. A desativação de cookies necessários pode afetar o funcionamento do site.',
            en: 'The user can configure the browser to block or delete cookies. Disabling necessary cookies may affect the site\'s operation.'
        },
        section4Text2: {
            pt: 'Mais informações em <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a>.',
            en: 'More information at <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a>.'
        },
        section5: {
            pt: '5. Cookies de terceiros',
            en: '5. Third-party cookies'
        },
        section5Text: {
            pt: 'Determinados serviços externos podem recolher dados de navegação. Nestes casos, os respetivos prestadores são responsáveis pelo tratamento e devem ser consultadas as suas políticas específicas.',
            en: 'Certain external services may collect browsing data. In these cases, the respective providers are responsible for processing and their specific policies should be consulted.'
        },
        section6: {
            pt: '6. Atualização',
            en: '6. Update'
        },
        section6Text: {
            pt: 'Esta Política de Cookies é revista sempre que ocorram alterações técnicas ou legais relevantes. Recomenda-se a consulta periódica desta página.',
            en: 'This Cookie Policy is reviewed whenever relevant technical or legal changes occur. Periodic consultation of this page is recommended.'
        },
        lastUpdate: {
            pt: '📅 Última atualização:',
            en: '📅 Last update:'
        },
        lastUpdateDate: {
            pt: '24 de novembro de 2025',
            en: 'November 24, 2025'
        },
        company: {
            pt: 'Roady Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.',
            en: 'Roady Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.'
        }
    },

    TERMS_CONDITIONS: {
        title: {
            pt: 'Termos & Condições de Utilização',
            en: 'Terms & Conditions of Use'
        },
        noticeTitle: {
            pt: 'Aviso Geral',
            en: 'General Notice'
        },
        noticeText1: {
            pt: 'A informação contida nesta página aplica-se a todo o portal www.roadyoliveiraazemeis.com.',
            en: 'The information on this page applies to the entire website www.roadyoliveiraazemeis.com.'
        },
        noticeText2: {
            pt: 'O presente website é da responsabilidade da Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda. (adiante designada por Roady Oliveira de Azeméis), pessoa coletiva registada sob o NIF 505209411, com sede no Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis.',
            en: 'This website is the responsibility of Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda. (hereinafter "Roady Oliveira de Azeméis"), a legal entity registered under VAT number 505209411, with registered office at Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis.'
        },
        noticeText3: {
            pt: 'Ao aceder e utilizar este website, o Utilizador reconhece e aceita estar vinculado aos presentes Termos e Condições de Utilização, sem necessidade de qualquer ato adicional de consentimento.',
            en: 'By accessing and using this website, the User acknowledges and accepts being bound by these Terms and Conditions of Use, without the need for any additional act of consent.'
        },
        section1: {
            pt: '1. Alterações e Disponibilidade',
            en: '1. Changes and Availability'
        },
        section1Text: {
            pt: 'O Roady Oliveira de Azeméis reserva-se o direito de, a qualquer momento e sem aviso prévio, alterar, atualizar, corrigir, suspender, interromper ou encerrar o website ou qualquer uma das suas funcionalidades. Estas ações poderão ser efetuadas por motivos técnicos, administrativos, comerciais ou legais, não podendo o Roady Oliveira de Azeméis ser responsabilizado por eventuais consequências decorrentes dessas alterações.',
            en: 'Roady Oliveira de Azeméis reserves the right to change, update, correct, suspend, interrupt or discontinue the website or any of its features at any time and without prior notice. Such actions may be taken for technical, administrative, commercial or legal reasons, and Roady Oliveira de Azeméis cannot be held liable for any consequences arising from such changes.'
        },
        section2: {
            pt: '2. Propriedade Intelectual',
            en: '2. Intellectual Property'
        },
        section2Text1: {
            pt: 'Todo o conteúdo presente neste website — incluindo, entre outros, textos, imagens, logótipos, marcas, vídeos, ícones, gráficos e elementos de design — é da propriedade exclusiva do Roady Oliveira de Azeméis ou de terceiros devidamente identificados, e encontra-se protegido por direitos de autor e legislação aplicável em matéria de propriedade intelectual e industrial.',
            en: 'All content on this website — including, but not limited to, texts, images, logos, trademarks, videos, icons, graphics and design elements — is the exclusive property of Roady Oliveira de Azeméis or of duly identified third parties, and is protected by copyright and applicable intellectual and industrial property law.'
        },
        section2Text2: {
            pt: 'O Utilizador apenas está autorizado a utilizar o website e os seus conteúdos para fins pessoais e não comerciais. Qualquer reprodução, cópia, difusão, modificação, transmissão, publicação ou exploração comercial, total ou parcial, carece de autorização prévia e expressa, por escrito, do Roady Oliveira de Azeméis.',
            en: 'The User is only authorised to use the website and its content for personal, non-commercial purposes. Any reproduction, copying, distribution, modification, transmission, publication or commercial exploitation, in whole or in part, requires the prior express written authorisation of Roady Oliveira de Azeméis.'
        },
        section3: {
            pt: '3. Utilização de Inteligência Artificial em Conteúdos',
            en: '3. Use of Artificial Intelligence in Content'
        },
        section3Text: {
            pt: 'Alguns dos conteúdos visuais apresentados neste website, nomeadamente imagens ilustrativas e de ambiente, podem ter sido criados ou editados com recurso a ferramentas de inteligência artificial. Estas imagens têm finalidade meramente ilustrativa e podem não representar com exatidão espaços, produtos, pessoas ou situações reais. As informações sobre produtos, serviços, preços e condições são reais e podem ser confirmadas junto do Roady Oliveira de Azeméis. Esta indicação é prestada em cumprimento dos deveres de transparência aplicáveis à utilização de inteligência artificial.',
            en: 'Some of the visual content on this website, in particular illustrative and ambient images, may have been created or edited using artificial intelligence tools. These images are for illustrative purposes only and may not accurately represent real spaces, products, people or situations. Information regarding products, services, prices and conditions is accurate and can be confirmed with Roady Oliveira de Azeméis. This notice is provided in compliance with the transparency obligations applicable to the use of artificial intelligence.'
        },
        section4: {
            pt: '4. Utilização do Website',
            en: '4. Use of the Website'
        },
        section4Text1: {
            pt: 'O acesso e utilização deste website são da inteira responsabilidade do Utilizador. O conteúdo é fornecido "tal como se encontra", sem garantias de qualquer tipo, expressas ou implícitas, incluindo, nomeadamente:',
            en: 'Access to and use of this website are the sole responsibility of the User. The content is provided "as is", without warranties of any kind, express or implied, including in particular:'
        },
        section4Item1: {
            pt: 'Garantias de comercialização, adequação a um fim específico ou inexistência de infração;',
            en: 'Warranties of merchantability, fitness for a particular purpose or non-infringement;'
        },
        section4Item2: {
            pt: 'Garantia de que o acesso é ininterrupto, livre de erros, vírus ou outras anomalias;',
            en: 'Warranty that access is uninterrupted, free of errors, viruses or other anomalies;'
        },
        section4Item3: {
            pt: 'Garantia de que as informações apresentadas são completas, exatas, atuais ou adequadas.',
            en: 'Warranty that the information presented is complete, accurate, current or adequate.'
        },
        section4Text2: {
            pt: 'O Roady Oliveira de Azeméis não assegura que o website funcione de forma contínua ou sem perturbações técnicas, podendo interromper temporariamente o seu funcionamento por razões de manutenção, atualização ou qualquer outra necessidade operacional.',
            en: 'Roady Oliveira de Azeméis does not guarantee that the website will operate continuously or without technical disruptions, and may temporarily interrupt its operation for maintenance, updates or any other operational need.'
        },
        section5: {
            pt: '5. Limitação de Responsabilidade',
            en: '5. Limitation of Liability'
        },
        section5Text1: {
            pt: 'Na extensão máxima permitida por lei, o Roady Oliveira de Azeméis, os seus administradores, colaboradores e representantes legais não poderão ser responsabilizados por quaisquer danos diretos, indiretos, incidentais, consequenciais ou especiais, incluindo perda de lucros, interrupção de atividade, danos em sistemas informáticos, perda de dados ou qualquer outro prejuízo resultante do uso ou impossibilidade de uso deste website.',
            en: 'To the maximum extent permitted by law, Roady Oliveira de Azeméis, its directors, employees and legal representatives may not be held liable for any direct, indirect, incidental, consequential or special damages, including loss of profits, business interruption, damage to computer systems, loss of data or any other loss arising from the use of or inability to use this website.'
        },
        section5Text2: {
            pt: 'O Roady Oliveira de Azeméis envida todos os esforços razoáveis para assegurar a exatidão e atualização das informações publicadas, mas não garante a ausência de erros nem se responsabiliza por omissões, inexatidões ou desatualizações, exceto em casos de dolo ou negligência grave.',
            en: 'Roady Oliveira de Azeméis makes all reasonable efforts to ensure the accuracy and currency of the information published, but does not guarantee the absence of errors and is not responsible for omissions, inaccuracies or outdated information, except in cases of wilful misconduct or gross negligence.'
        },
        section6: {
            pt: '6. Ligações a Websites de Terceiros',
            en: '6. Links to Third-Party Websites'
        },
        section6Text1: {
            pt: 'O website www.roadyoliveiraazemeis.com pode conter hiperligações para websites externos. Tais ligações são disponibilizadas unicamente para conveniência do Utilizador, não implicando qualquer responsabilidade ou aprovação do Roady Oliveira de Azeméis relativamente aos conteúdos, produtos, serviços ou políticas desses websites.',
            en: 'The website www.roadyoliveiraazemeis.com may contain hyperlinks to external websites. Such links are provided solely for the User\'s convenience and do not imply any responsibility or approval by Roady Oliveira de Azeméis regarding the content, products, services or policies of those websites.'
        },
        section6Text2: {
            pt: 'Recomenda-se ao Utilizador a leitura atenta dos termos de utilização e políticas de privacidade aplicáveis a quaisquer websites de terceiros que venha a visitar.',
            en: 'Users are advised to carefully read the terms of use and privacy policies applicable to any third-party websites they visit.'
        },
        section7: {
            pt: '7. Referências a Marcas e Produtos de Terceiros',
            en: '7. References to Third-Party Brands and Products'
        },
        section7Text1: {
            pt: 'O Roady Oliveira de Azeméis pode, em determinadas secções do website, mencionar marcas, produtos ou designações comerciais de terceiros exclusivamente para fins informativos e descritivos, com o objetivo de identificar produtos genuínos disponíveis em loja ou serviços compatíveis.',
            en: 'Roady Oliveira de Azeméis may, in certain sections of the website, mention brands, products or trade names of third parties solely for informational and descriptive purposes, in order to identify genuine products available in-store or compatible services.'
        },
        section7Note: {
            pt: 'Nota Legal: Todas as marcas e designações comerciais mencionadas neste website são propriedade dos respetivos titulares registados. O Roady Oliveira de Azeméis utiliza essas referências apenas para fins informativos, descritivos e de identificação comercial legítima, sem qualquer apropriação ou relação de representação oficial com os respetivos detentores de direitos.',
            en: 'Legal Notice: All brands and trade names mentioned on this website are the property of their respective registered owners. Roady Oliveira de Azeméis uses these references solely for informational, descriptive and legitimate commercial identification purposes, without any appropriation or official representation relationship with the respective rights holders.'
        },
        section8: {
            pt: '8. Contactos e Identificação Legal',
            en: '8. Contacts and Legal Identification'
        },
        section8Company: {
            pt: 'Nome Social:',
            en: 'Company Name:'
        },
        section8CompanyValue: {
            pt: 'Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.',
            en: 'Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.'
        },
        section8NIF: {
            pt: 'NIF:',
            en: 'VAT Number:'
        },
        section8NIFValue: {
            pt: '505209411',
            en: '505209411'
        },
        section8Address: {
            pt: 'Sede:',
            en: 'Registered Office:'
        },
        section8AddressValue: {
            pt: 'Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis',
            en: 'Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis'
        },
        section8Responsible: {
            pt: 'Responsável:',
            en: 'Responsible:'
        },
        section8ResponsibleValue: {
            pt: 'A Gerência',
            en: 'Management'
        },
        section8Phone: {
            pt: 'Telefone:',
            en: 'Phone:'
        },
        section8PhoneValue: {
            pt: '(+351) 256 665 200',
            en: '(+351) 256 665 200'
        },
        section8Email: {
            pt: 'Correio Eletrónico:',
            en: 'Email:'
        },
        section8EmailValue: {
            pt: 'geral@roadyoliveiraazemeis.com',
            en: 'geral@roadyoliveiraazemeis.com'
        },
        section9: {
            pt: '9. Atualização dos Termos',
            en: '9. Updates to the Terms'
        },
        section9Text: {
            pt: 'Estes Termos e Condições foram revistos e atualizados pela última vez em 04 de agosto de 2026. O Roady Oliveira de Azeméis reserva-se o direito de proceder a atualizações periódicas, sendo a versão em vigor sempre a mais recente publicada em www.roadyoliveiraazemeis.com.',
            en: 'These Terms and Conditions were last reviewed and updated on 4 August 2026. Roady Oliveira de Azeméis reserves the right to make periodic updates, with the version in force always being the most recent one published at www.roadyoliveiraazemeis.com.'
        },
        section10: {
            pt: '10. Lei Aplicável e Foro Competente',
            en: '10. Applicable Law and Jurisdiction'
        },
        section10Text: {
            pt: 'Os presentes Termos e Condições regem-se pela lei portuguesa. Qualquer litígio emergente da sua interpretação, validade ou execução será submetido à jurisdição exclusiva dos tribunais da comarca de Setúbal, com expressa renúncia a qualquer outro.',
            en: 'These Terms and Conditions are governed by Portuguese law. Any dispute arising from their interpretation, validity or performance shall be submitted to the exclusive jurisdiction of the courts of the district of Setúbal, with express waiver of any other.'
        },
        contact: {
            pt: 'Contacto',
            en: 'Contact'
        }
    },

    HOURS: {
        tagline: {
            pt: 'Horário de Funcionamento',
            en: 'Opening Hours'
        },
        title: {
            pt: 'Onde estamos e <span>quando estamos abertos</span>',
            en: 'Where we are and <span>when we are open</span>'
        },
        description: {
            pt: 'Visite-nos durante nosso horário de funcionamento para serviços de loja e oficina. Estamos aqui para atendê-lo!',
            en: 'Visit us during our opening hours for store and workshop services. We are here to serve you!'
        },
        store: {
            pt: 'LOJA',
            en: 'STORE'
        },
        workshop: {
            pt: 'OFICINA',
            en: 'WORKSHOP'
        },
        weekdays: {
            pt: 'Seg-Sáb',
            en: 'Mon-Sat'
        },
        sunday: {
            pt: 'Domingo',
            en: 'Sunday'
        },
        holidays: {
            pt: 'Feriados',
            en: 'Holidays'
        },
        contactUs: {
            pt: 'Fale Connosco',
            en: 'Contact Us'
        }
    },

    PRIVACY_POLICY: {
        title: {
            pt: 'Política de Privacidade',
            en: 'Privacy Policy'
        },
        subtitle: {
            pt: 'Roady Centro-Auto Oliveira de Azeméis',
            en: 'Roady Centro-Auto Oliveira de Azeméis'
        },
        section1: {
            pt: '1. Enquadramento',
            en: '1. Framework'
        },
        section1Text: {
            pt: 'A presente Política de Privacidade explica como o Roady Centro-Auto Oliveira de Azeméis (Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.) trata os dados pessoais dos utilizadores do website www.roadyoliveiraazemeis.com, em conformidade com o Regulamento (UE) 2016/679 (RGPD) e com a Lei n.º 58/2019, de 8 de agosto. Esta política complementa os Termos & Condições de Utilização.',
            en: 'This Privacy Policy explains how Roady Centro-Auto Oliveira de Azeméis (Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.) processes personal data of users of the website www.roadyoliveiraazemeis.com, in accordance with Regulation (EU) 2016/679 (GDPR) and Law No. 58/2019, of August 8. This policy complements the Terms & Conditions of Use.'
        },
        section2: {
            pt: '2. Responsável pelo tratamento',
            en: '2. Data Controller'
        },
        section2Company: {
            pt: 'Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.',
            en: 'Station Oliveira de Azeméis – Centro de Manutenção de Veículos, Lda.'
        },
        section2Text1: {
            pt: 'NIF 505 209 411',
            en: 'NIF 505 209 411'
        },
        section2Text2: {
            pt: 'Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis',
            en: 'Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis'
        },
        section2Text3: {
            pt: '📧 geral@roadyoliveiraazemeis.com',
            en: '📧 geral@roadyoliveiraazemeis.com'
        },
        section2Text4: {
            pt: '📞 (+351) 256 665 200',
            en: '📞 (+351) 256 665 200'
        },
        section3: {
            pt: '3. Dados recolhidos',
            en: '3. Data Collected'
        },
        section3Item1: {
            pt: 'Identificação e contacto: nome, email, telefone, empresa (se aplicável);',
            en: 'Identification and contact: name, email, phone, company (if applicable);'
        },
        section3Item2: {
            pt: 'Dados de viatura/serviço: matrícula, marca/modelo, tipo de serviço;',
            en: 'Vehicle/service data: license plate, brand/model, service type;'
        },
        section3Item3: {
            pt: 'Dados técnicos de navegação: endereço IP, browser, páginas visitadas, data e hora de acesso.',
            en: 'Technical navigation data: IP address, browser, pages visited, date and time of access.'
        },
        section3Text: {
            pt: 'O website não recolhe nem solicita dados sensíveis.',
            en: 'The website does not collect or request sensitive data.'
        },
        section4: {
            pt: '4. Finalidades',
            en: '4. Purposes'
        },
        section4Text: {
            pt: 'Os dados são tratados para:',
            en: 'Data is processed to:'
        },
        section4Item1: {
            pt: 'gerir pedidos de orçamento ou marcação de serviços;',
            en: 'manage quotation requests or service appointments;'
        },
        section4Item2: {
            pt: 'responder a pedidos de informação;',
            en: 'respond to information requests;'
        },
        section4Item3: {
            pt: 'garantir a segurança e melhoria do website;',
            en: 'ensure security and improvement of the website;'
        },
        section4Item4: {
            pt: 'cumprir obrigações legais aplicáveis.',
            en: 'comply with applicable legal obligations.'
        },
        section4Text2: {
            pt: 'Qualquer comunicação promocional será enviada apenas com consentimento prévio e explícito do titular.',
            en: 'Any promotional communication will only be sent with prior and explicit consent from the data subject.'
        },
        section5: {
            pt: '5. Fundamento jurídico',
            en: '5. Legal Basis'
        },
        section5Text: {
            pt: 'O tratamento assenta em:',
            en: 'Processing is based on:'
        },
        section5Item1: {
            pt: 'execução de diligências pré-contratuais ou contratuais;',
            en: 'execution of pre-contractual or contractual measures;'
        },
        section5Item2: {
            pt: 'cumprimento de obrigação legal;',
            en: 'compliance with legal obligation;'
        },
        section5Item3: {
            pt: 'interesse legítimo do Roady Oliveira de Azeméis na gestão do site;',
            en: 'legitimate interest of Roady Oliveira de Azeméis in site management;'
        },
        section5Item4: {
            pt: 'consentimento do titular (quando aplicável).',
            en: 'data subject consent (when applicable).'
        },
        section6: {
            pt: '6. Prazos de conservação',
            en: '6. Retention Periods'
        },
        section6Text: {
            pt: 'Os dados são guardados apenas pelo tempo necessário à finalidade:',
            en: 'Data is stored only for the time necessary for the purpose:'
        },
        section6Item1: {
            pt: 'orçamentos/marcações – até 12 meses após o último contacto;',
            en: 'quotations/appointments – up to 12 months after last contact;'
        },
        section6Item2: {
            pt: 'dados fiscais – pelos prazos legais de contabilidade;',
            en: 'fiscal data – by legal accounting deadlines;'
        },
        section6Item3: {
            pt: 'cookies – pelos prazos definidos na Política de Cookies.',
            en: 'cookies – by deadlines defined in Cookie Policy.'
        },
        section6Text2: {
            pt: 'Findo o prazo, são eliminados ou anonimizados.',
            en: 'After the deadline, they are deleted or anonymized.'
        },
        section7: {
            pt: '7. Partilha de dados',
            en: '7. Data Sharing'
        },
        section7Text: {
            pt: 'Os dados podem ser partilhados apenas com:',
            en: 'Data may be shared only with:'
        },
        section7Item1: {
            pt: 'prestadores de serviços técnicos (hospedagem, manutenção web);',
            en: 'technical service providers (hosting, web maintenance);'
        },
        section7Item2: {
            pt: 'autoridades públicas, quando exista obrigação legal;',
            en: 'public authorities, when there is a legal obligation;'
        },
        section7Item3: {
            pt: 'ferramentas analíticas (ex.: Google Analytics) — apenas com consentimento.',
            en: 'analytical tools (e.g.: Google Analytics) — only with consent.'
        },
        section7Text2: {
            pt: 'Em todos os casos são aplicadas garantias contratuais e técnicas adequadas.',
            en: 'In all cases, adequate contractual and technical guarantees are applied.'
        },
        section8: {
            pt: '8. Direitos dos titulares',
            en: '8. Data Subject Rights'
        },
        section8Text: {
            pt: 'O utilizador pode exercer, gratuitamente, os seguintes direitos: acesso, retificação, apagamento, limitação, portabilidade, oposição e retirada de consentimento.',
            en: 'The user may exercise, free of charge, the following rights: access, rectification, erasure, restriction, portability, objection and withdrawal of consent.'
        },
        section8Text2: {
            pt: 'Os pedidos devem ser enviados para <a href="mailto:geral@roadyoliveiraazemeis.com">geral@roadyoliveiraazemeis.com</a>.',
            en: 'Requests must be sent to <a href="mailto:geral@roadyoliveiraazemeis.com">geral@roadyoliveiraazemeis.com</a>.'
        },
        section8Text3: {
            pt: 'O titular pode ainda reclamar junto da CNPD – Comissão Nacional de Proteção de Dados (<a href="https://www.cnpd.pt" target="_blank">www.cnpd.pt</a>).',
            en: 'The data subject may also file a complaint with CNPD – National Commission for Data Protection (<a href="https://www.cnpd.pt" target="_blank">www.cnpd.pt</a>).'
        },
        section9: {
            pt: '9. Segurança',
            en: '9. Security'
        },
        section9Text: {
            pt: 'São adotadas medidas técnicas e organizativas adequadas para proteger os dados pessoais contra perda, alteração, acesso não autorizado ou destruição.',
            en: 'Appropriate technical and organizational measures are adopted to protect personal data against loss, alteration, unauthorized access or destruction.'
        },
        section10: {
            pt: '10. Transferências internacionais',
            en: '10. International Transfers'
        },
        section10Text: {
            pt: 'Os dados não são transferidos para fora da União Europeia. Se tal ocorrer, serão aplicadas as cláusulas-tipo de proteção de dados aprovadas pela Comissão Europeia.',
            en: 'Data is not transferred outside the European Union. If such occurs, standard data protection clauses approved by the European Commission will be applied.'
        },
        section11: {
            pt: '11. Atualizações',
            en: '11. Updates'
        },
        section11Text: {
            pt: 'Esta Política de Privacidade pode ser atualizada sempre que necessário. A versão publicada em www.roadyoliveiraazemeis.com é a que se encontra em vigor.',
            en: 'This Privacy Policy may be updated whenever necessary. The version published at www.roadyoliveiraazemeis.com is the one in force.'
        },
        contact: {
            pt: 'Contacto',
            en: 'Contact'
        },
        contactEmail: {
            pt: 'Email:',
            en: 'Email:'
        },
        contactPhone: {
            pt: 'Telefone:',
            en: 'Phone:'
        },
        contactAddress: {
            pt: 'Morada:',
            en: 'Address:'
        },
        contactAddressValue: {
            pt: 'Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis',
            en: 'Sítio do Esteval, Av. Antero Brotas, 2870-458 Oliveira de Azeméis'
        }
    },

    RECRUITMENT: {
        title: {
            pt: 'Junte-se à Nossa Equipa',
            en: 'Join Our Team'
        },
        description: {
            pt: 'Candidate-se a uma posição na Roady Oliveira de Azeméis. Todos os campos assinalados * são obrigatórios.',
            en: 'Apply for a position at Roady Oliveira de Azeméis. All fields marked * are required.'
        },
        labelName: {
            pt: 'Nome *',
            en: 'Name *'
        },
        placeholderName: {
            pt: 'Insira o seu nome',
            en: 'Enter your name'
        },
        labelSurname: {
            pt: 'Apelido *',
            en: 'Surname *'
        },
        placeholderSurname: {
            pt: 'Insira o seu apelido',
            en: 'Enter your surname'
        },
        labelEmail: {
            pt: 'Endereço de Email *',
            en: 'Email Address *'
        },
        placeholderEmail: {
            pt: 'Insira o seu email',
            en: 'Enter your email address'
        },
        labelPhone: {
            pt: 'Número de Telefone *',
            en: 'Phone Number *'
        },
        placeholderPhone: {
            pt: 'Insira o seu número de telefone',
            en: 'Enter your phone number'
        },
        labelCurrentSituation: {
            pt: 'Situação Atual *',
            en: 'Current Situation *'
        },
        optionChoose: {
            pt: 'Escolher...',
            en: 'Choose...'
        },
        optionStudent: {
            pt: 'Estudante',
            en: 'Student'
        },
        optionUnemployed: {
            pt: 'Desempregado',
            en: 'Unemployed'
        },
        optionEmployed: {
            pt: 'Empregado',
            en: 'Employed'
        },
        labelPosition: {
            pt: 'Posição a que se Candidata *',
            en: 'Position Applying For *'
        },
        optionChoosePosition: {
            pt: 'Escolha uma posição...',
            en: 'Choose a position...'
        },
        optionVendedorRececionista: {
            pt: 'Vendedor / Rececionista',
            en: 'Salesperson / Receptionist'
        },
        optionOrcamentista: {
            pt: 'Orçamentista',
            en: 'Estimator'
        },
        optionMecanico: {
            pt: 'Mecânico',
            en: 'Mechanic'
        },
        optionEletricista: {
            pt: 'Eletricista',
            en: 'Electrician'
        },
        optionMecatronico: {
            pt: 'Mecatrónico',
            en: 'Mechatronics Technician'
        },
        optionAprendizMecanico: {
            pt: 'Aprendiz de Mecânico',
            en: 'Mechanic Apprentice'
        },
        optionContabilistaAdministrativo: {
            pt: 'Contabilista / Administrativo',
            en: 'Accountant / Administrative'
        },
        optionOperadorRepositor: {
            pt: 'Operador / Repositor',
            en: 'Operator / Stocker'
        },
        labelMessage: {
            pt: 'Mensagem',
            en: 'Message'
        },
        placeholderMessage: {
            pt: 'Mensagem adicional (opcional)',
            en: 'Additional message (optional)'
        },
        labelUploadCV: {
            pt: 'Carregar CV',
            en: 'Upload CV'
        },
        cvHelpText: {
            pt: 'Carregue o seu CV em formato PDF, DOC ou DOCX',
            en: 'Upload your CV in PDF, DOC, or DOCX format'
        },
        submitApplication: {
            pt: 'Enviar Candidatura',
            en: 'Submit Application'
        },
        pleaseWait: {
            pt: 'Por favor aguarde...',
            en: 'Please wait...'
        },
        fillRequiredFields: {
            pt: 'Por favor, preencha todos os campos obrigatórios.',
            en: 'Please fill in all required fields.'
        }
    }
};

// Export for use in other files
export default translations;

// Also make available on window for backwards compatibility
if (typeof window !== 'undefined') {
    (window as any).translations = translations;
}
